<template>

    <templatesite>

        <template v-slot:appheader> <appheader></appheader> </template>
        <template v-slot:appsidebar> <appsidebar></appsidebar> </template>
        <template v-slot:appcontent>

            <div class="content" style="margin-top: 5%!important;">
                <div class="main-content">

                    <div :class="['cui', { 'cui-plein': pleinEcran }]">

                        <!-- ══════════ EN-TÊTE ══════════ -->
                        <div class="cui-head">
                            <div class="cui-head-l">
                                <span class="cui-poste"><i :class="ui.icone"></i> {{ ui.titre }}</span>
                                <div class="cui-head-txt">
                                    <h1 class="cui-title">Écran de production</h1>
                                    <span class="cui-sub">Bons reçus de la caisse &middot; {{ dateDuJour }}</span>
                                </div>
                            </div>

                            <div class="cui-head-r">
                                <button class="cui-voyant" :class="'v-' + etatRoom" @click="basculerConnexion"
                                        :title="etatRoom === 'connecte'
                                            ? 'Rattaché à ' + roomCaisse + ' - cliquer pour se déconnecter'
                                            : 'Hors ligne - cliquer pour se connecter à une caisse'">
                                    <span class="cui-dot"></span>
                                    <span>{{ libelleEtatRoom }}</span>
                                </button>

                                <!-- Voyant TEMPS RÉEL : le lien socket vers la caisse.
                                     Distinct du voyant d'appairage ci-dessus - l'un dit
                                     « cet écran a le droit », celui-ci dit « le canal
                                     live est actif et les bons arrivent en direct ».
                                     Vert = socket connecté ; ambre = rattaché mais canal
                                     coupé/en cours ; masqué tant que non rattaché. -->
                                <div v-if="etatRoom === 'connecte'"
                                     class="cui-rt" :class="rtConnecte ? 'rt-on' : 'rt-wait'"
                                     :title="rtConnecte
                                        ? 'Connecté à la caisse en temps réel - les bons arrivent en direct'
                                        : 'Rattaché mais canal temps réel coupé - reconnexion en cours'">
                                    <span class="cui-rt-dot"></span>
                                    <i :class="rtConnecte ? 'ri-links-line' : 'ri-link-unlink-m'"></i>
                                    <span class="cui-rt-txt">{{ rtConnecte ? 'Caisse en direct' : 'Reconnexion…' }}</span>
                                </div>

                                <button class="cui-ibtn" :class="{ 'ib-off': !alerteActive }"
                                        @click="alerteActive = !alerteActive"
                                        :title="alerteActive ? 'Couper l\'alerte sonore' : 'Activer l\'alerte sonore'">
                                    <i :class="alerteActive ? 'ri-volume-up-line' : 'ri-volume-mute-line'"></i>
                                </button>

                                <button class="cui-ibtn" @click="testerAlerte" title="Tester le son et la vibration">
                                    <i class="ri-notification-4-line"></i>
                                </button>

                                <button class="cui-ibtn" @click="pleinEcran = !pleinEcran"
                                        :title="pleinEcran ? 'Quitter le plein écran' : 'Plein écran'">
                                    <i :class="pleinEcran ? 'ri-fullscreen-exit-line' : 'ri-fullscreen-line'"></i>
                                </button>
                            </div>
                        </div>

                        <!-- ══════════ BANDEAU DE RATTACHEMENT ══════════
                             Sorti de la barre d'outils, où il passait inaperçu entre
                             les boutons. Un poste mural doit prévenir AVANT que son
                             autorisation tombe, pas au moment où la cuisine est pleine.
                             Visible en permanence dès que l'écran est rattaché. -->
                        <div v-if="etatRoom === 'connecte'" class="cui-jeton" :class="'jt-' + urgenceJeton">
                            <div class="cui-jeton-ico">
                                <i :class="urgenceJeton === 'ok' ? 'ri-shield-check-line' : 'ri-shield-flash-line'"></i>
                            </div>
                            <div class="cui-jeton-corps">
                                <div class="cui-jeton-l1">
                                    <strong>Écran rattaché</strong>
                                    <span v-if="ecran">
                                        {{ ecran.posteLibelle }}
                                        <template v-if="ecran.libelle"> · {{ ecran.libelle }}</template>
                                        <!-- Nom de la caisse, jamais son pid : celui-ci fait
                                             une centaine de caractères et n'apprend rien. -->
                                        <template v-if="ecran.namecaisse"> · {{ ecran.namecaisse }}</template>
                                    </span>
                                </div>
                                <div class="cui-jeton-l2">
                                    <template v-if="jetonExpireAt">
                                        Jeton expire le <b>{{ dateLongue(jetonExpireAt) }}</b>
                                    </template>
                                    <template v-else>Autorisation sans échéance connue</template>
                                </div>
                            </div>
                            <div class="cui-jeton-reste">
                                <span>{{ resteJeton }}</span>
                                <em v-if="urgenceJeton === 'fin'">Demandez un nouveau code</em>
                                <em v-else-if="urgenceJeton === 'mort'">Autorisation expirée</em>
                            </div>
                            <button class="cui-jeton-off" @click="basculerConnexion" title="Détacher cet écran">
                                <i class="ri-link-unlink"></i>
                            </button>
                        </div>

                        <!-- ══════════ BANDEAU DE CONNEXION ══════════ -->
                        <div v-if="etatRoom !== 'connecte'" class="cui-connect">
                            <div class="cui-connect-ico"><i class="ri-link-unlink-m"></i></div>
                            <div class="cui-connect-body">
                                <strong>Cet écran n'est rattaché à aucune caisse</strong>
                                <p>
                                    Ouvrez la caisse en mode Restaurant, menu
                                    <em>Autoriser un écran &rsaquo; {{ ui.entree }}</em>, puis saisissez le code affiché.
                                </p>
                                <div class="cui-connect-row">
                                    <!-- Code à 6 chiffres : clavier numérique sur tablette,
                                         et on filtre la saisie pour qu'un espace recopié
                                         depuis l'affichage de la caisse ne bloque rien. -->
                                    <input v-model="codeSaisi" maxlength="7" placeholder="000000"
                                           type="text" inputmode="numeric" autocomplete="off"
                                           class="cui-code" :disabled="etatRoom === 'connexion'"
                                           @input="codeSaisi = codeSaisi.replace(/\D/g, '').slice(0, 6)"
                                           @keydown.enter.prevent="connecter" />
                                    <button class="cui-btn cui-btn-pri" @click="connecter"
                                            :disabled="etatRoom === 'connexion' || codeSaisi.trim().length < 6">
                                        <i :class="etatRoom === 'connexion' ? 'ri-loader-4-line cui-spin' : 'ri-link'"></i>
                                        {{ etatRoom === 'connexion' ? 'Connexion…' : 'Se connecter' }}
                                    </button>
                                </div>
                                <span v-if="erreurRoom" class="cui-connect-err">
                                    <i class="ri-error-warning-line"></i> {{ erreurRoom }}
                                </span>
                            </div>
                        </div>

                        <!-- ══════════ ONGLETS ══════════ -->
                        <div class="cui-tabs">
                            <button :class="['cui-tab', { on: onglet === 'service' }]" @click="onglet = 'service'">
                                <i class="ri-fire-line"></i> Service
                                <span v-if="nbActifs > 0" class="cui-tab-badge">{{ nbActifs }}</span>
                            </button>
                            <button :class="['cui-tab', { on: onglet === 'historique' }]" @click="onglet = 'historique'">
                                <i class="ri-file-list-3-line"></i> Point des ventes
                            </button>
                            <button :class="['cui-tab', { on: onglet === 'performance' }]" @click="ouvrirPerformance">
                                <i class="ri-speed-up-line"></i> Analyse de performance
                            </button>
                            <button :class="['cui-tab', { on: onglet === 'tracabilite' }]" @click="onglet = 'tracabilite'">
                                <i class="ri-route-line"></i> Traçabilité
                                <span v-if="nbRetoursPeriode > 0" class="cui-tab-badge cui-tab-badge-warn">
                                    {{ nbRetoursPeriode }}
                                </span>
                            </button>
                        </div>

                        <!-- ══════════════════════════════════════════════════
                             ONGLET SERVICE
                        ══════════════════════════════════════════════════ -->
                        <div v-show="onglet === 'service'" class="cui-service">

                        <!-- L'écran est branché mais la caisse ne lui envoie encore
                             rien : la réception des bons n'est pas construite. On le
                             dit, plutôt que de laisser croire à un service calme. -->
                        <div v-if="etatRoom === 'connecte' && bons.length === 0" class="cui-attente">
                            <i class="ri-inbox-line"></i>
                            <div>
                                <strong>Aucun bon reçu</strong>
                                <span>La caisse n'envoie pas encore les commandes vers cet écran.</span>
                            </div>
                        </div>

                        <div class="cui-board">
                            <div v-for="etape in ETAPES" :key="etape.code" class="cui-col">

                                <div class="cui-col-head" :style="{ '--c': etape.couleur }">
                                    <span class="cui-col-title">
                                        <i :class="etape.icone"></i> {{ etape.libelle }}
                                    </span>
                                    <span class="cui-col-count">{{ parEtape(etape.code).length }}</span>
                                </div>

                                <button v-if="etape.code === 'recu' && parEtape('recu').length > 1"
                                        class="cui-col-bulk" @click="toutDemarrer">
                                    <i class="ri-play-circle-line"></i> Tout démarrer ({{ parEtape('recu').length }})
                                </button>

                                <div class="cui-col-body">
                                    <div v-if="parEtape(etape.code).length === 0" class="cui-vide">
                                        <i :class="etape.icone"></i>
                                        <span>Aucun bon</span>
                                    </div>

                                    <article v-for="b in parEtape(etape.code)" :key="b.id"
                                             :class="['cui-card', 'urg-' + urgence(b), { 'cui-neuf': b.id === dernierRecu }]">

                                        <header class="cui-card-h">
                                            <span class="cui-num">
                                                {{ b.numeroBon }}
                                                <!-- Un bon qui a reculé au moins une fois le signale ici,
                                                     et le détail est consultable dans l'onglet Traçabilité. -->
                                                <button v-if="nbRetours(b) > 0" class="cui-retour-flag"
                                                        @click="ouvrirTracabilite(b)"
                                                        :title="nbRetours(b) + ' retour(s) - voir le parcours'">
                                                    <i class="ri-arrow-go-back-line"></i>{{ nbRetours(b) }}
                                                </button>
                                            </span>

                                            <!-- ── DÉCOMPTE ──
                                                 Un chronomètre qui monte ne dit pas si on est en
                                                 retard. On compte donc à REBOURS vers l'heure de
                                                 sortie cible (réception + objectif du plat le plus
                                                 long), et on bascule en dépassement au-delà. -->
                                            <span v-if="enCours(b)" class="cui-cd"
                                                  :class="'cd-' + urgence(b)"
                                                  :title="'Objectif ' + b.objectif + ' min · sortie visée à ' + heureCible(b)">
                                                <i :class="restantSec(b) < 0 ? 'ri-alarm-warning-line' : 'ri-timer-line'"></i>
                                                {{ decompte(b) }}
                                            </span>
                                            <span v-else class="cui-chrono">
                                                <i class="ri-time-line"></i> {{ duree(b.recuAt, b.pretAt) }}
                                            </span>
                                        </header>

                                        <!-- Barre de progression vers l'objectif -->
                                        <div v-if="enCours(b)" class="cui-jauge">
                                            <div class="cui-jauge-fill" :class="'jf-' + urgence(b)"
                                                 :style="{ width: avancement(b) + '%' }"></div>
                                        </div>

                                        <div class="cui-meta">
                                            <span class="cui-tag tag-table"><i class="ri-table-line"></i> {{ b.table.name }}</span>
                                            <span class="cui-tag"><i class="ri-user-line"></i> {{ b.serveur.name }}</span>
                                            <span class="cui-tag tag-soft"><i class="ri-cash-line"></i> {{ b.caisse.name }}</span>
                                        </div>
                                        <div class="cui-meta cui-meta-num">
                                            <span title="Numéro de la commande côté caisse">Cmd {{ b.numeroCommande }}</span>
                                            <span title="Numéro envoyé par le serveur">Srv {{ b.numeroServeur }}</span>
                                            <span v-if="b.client" class="cui-client">{{ b.client }}</span>
                                        </div>

                                        <ul class="cui-lignes">
                                            <li v-for="l in b.lignes" :key="l.id"
                                                :class="{ fait: lignesFaites[l.id] }"
                                                @click="lignesFaites[l.id] = !lignesFaites[l.id]">
                                                <span class="cui-qte">{{ l.qte }}×</span>
                                                <span class="cui-plat">
                                                    {{ l.nom }}
                                                    <em v-if="l.accompagnement"> + {{ l.accompagnement }}</em>
                                                    <span v-if="l.note" class="cui-note">
                                                        <i class="ri-sticky-note-line"></i> {{ l.note }}
                                                    </span>
                                                </span>
                                                <span class="cui-obj">{{ l.objectif }}'</span>
                                                <i class="ri-check-line cui-tick"></i>
                                            </li>
                                        </ul>

                                        <!-- ── HORODATAGE DE LA NOTIFICATION ──
                                             Visible dès que le bon est prêt : c'est la trace de
                                             qui a été prévenu, quand, et à quel moment le serveur
                                             a réagi. C'est ce qui rend le délai de salle mesurable. -->
                                        <div v-if="b.pretAt" class="cui-timeline">
                                            <span class="tl tl-ok">
                                                <i class="ri-checkbox-circle-line"></i> Prêt {{ heure(b.pretAt) }}
                                            </span>
                                            <span class="tl" :class="b.notifieAt ? 'tl-ok' : 'tl-ko'">
                                                <i class="ri-send-plane-line"></i>
                                                {{ b.notifieAt ? 'Notifié ' + heure(b.notifieAt) : 'Non remis' }}
                                            </span>
                                            <span class="tl" :class="b.vuAt ? 'tl-ok' : 'tl-attente'">
                                                <i class="ri-eye-line"></i>
                                                {{ b.vuAt ? 'Vu ' + heure(b.vuAt) : 'Pas encore vu' }}
                                            </span>
                                            <span v-if="b.serviAt" class="tl tl-ok">
                                                <i class="ri-walk-line"></i> Enlevé {{ heure(b.serviAt) }}
                                            </span>
                                            <span v-if="b.vuAt" class="tl tl-info">
                                                Réponse salle : {{ duree(b.notifieAt || b.pretAt, b.vuAt) }}
                                            </span>
                                        </div>

                                        <footer class="cui-card-f">
                                            <button v-if="etapePrecedente(b.statut)" class="cui-back"
                                                    @click="reculer(b)" :title="'Revenir à ' + libelleEtape(etapePrecedente(b.statut))">
                                                <i class="ri-arrow-left-line"></i>
                                            </button>

                                            <button v-if="etapeSuivante(b.statut)" class="cui-next"
                                                    :style="{ '--c': couleurEtape(etapeSuivante(b.statut)) }"
                                                    @click="avancer(b)">
                                                {{ libelleAction(b.statut) }}
                                                <i class="ri-arrow-right-line"></i>
                                            </button>
                                            <span v-else class="cui-done"><i class="ri-check-double-line"></i> Terminé</span>
                                        </footer>
                                    </article>
                                </div>
                            </div>
                        </div>
                        </div><!-- /cui-service -->

                        <!-- ══════════════════════════════════════════════════
                             ONGLET POINT DES VENTES
                        ══════════════════════════════════════════════════ -->
                        <div v-show="onglet === 'historique'" class="cui-hist">

                            <div class="cui-filtres">
                                <div class="cui-presets">
                                    <button v-for="p in PRESETS" :key="p.code"
                                            :class="['cui-preset', { on: preset === p.code }]"
                                            @click="appliquerPreset(p.code)">{{ p.libelle }}</button>
                                </div>
                                <div class="cui-filtre-grp">
                                    <label>Du</label>
                                    <input type="date" v-model="dateDebut" @change="preset = 'perso'" class="cui-input" />
                                    <label>au</label>
                                    <input type="date" v-model="dateFin" @change="preset = 'perso'" class="cui-input" />
                                </div>
                                <div class="cui-filtre-grp">
                                    <select v-model="filtreServeur" class="cui-input">
                                        <option value="">Tous les serveurs</option>
                                        <option v-for="s in serveursDisponibles" :key="s.pid" :value="s.pid">{{ s.name }}</option>
                                    </select>
                                    <select v-model="filtreCaisse" class="cui-input">
                                        <option value="">Toutes les caisses</option>
                                        <option v-for="c in caissesDisponibles" :key="c.pid" :value="c.pid">{{ c.name }}</option>
                                    </select>
                                    <select v-model="filtreStatut" class="cui-input">
                                        <option value="">Tous les statuts</option>
                                        <option value="servi">Servies</option>
                                        <option value="annule">Annulées</option>
                                    </select>
                                </div>
                            </div>

                            <div class="cui-kpis">
                                <div class="cui-kpi"><span class="cui-kpi-l">Bons reçus</span><strong>{{ kpi.bons }}</strong></div>
                                <div class="cui-kpi"><span class="cui-kpi-l">Plats préparés</span><strong>{{ kpi.plats }}</strong></div>
                                <div class="cui-kpi"><span class="cui-kpi-l">Délai moyen de préparation</span><strong>{{ kpi.delaiPrep }}</strong></div>
                                <div class="cui-kpi"><span class="cui-kpi-l">Délai moyen jusqu'au service</span><strong>{{ kpi.delaiServi }}</strong></div>
                                <div class="cui-kpi cui-kpi-warn"><span class="cui-kpi-l">Annulées</span><strong>{{ kpi.annulees }}</strong></div>
                            </div>

                            <div class="cui-table-wrap">
                                <table class="cui-table">
                                    <thead>
                                        <tr>
                                            <th>Date</th><th>Heure</th><th>N&deg; bon</th><th>N&deg; commande</th>
                                            <th>N&deg; serveur</th><th>Caisse</th><th>Serveur</th><th>Table</th>
                                            <th class="ta-r">Plats</th>
                                            <th class="ta-r">Prêt à</th>
                                            <th class="ta-r">Notifié à</th>
                                            <th class="ta-r">Vu à</th>
                                            <th class="ta-r">Réponse</th>
                                            <th>Statut</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="b in pageHistorique" :key="b.id">
                                            <td>{{ jour(b.recuAt) }}</td>
                                            <td>{{ heure(b.recuAt) }}</td>
                                            <td class="cui-td-num">{{ b.numeroBon }}</td>
                                            <td>{{ b.numeroCommande }}</td>
                                            <td>{{ b.numeroServeur }}</td>
                                            <td>{{ b.caisse.name }}</td>
                                            <td>{{ b.serveur.name }}</td>
                                            <td>{{ b.table.name }}</td>
                                            <td class="ta-r">{{ nbPlats(b) }}</td>
                                            <td class="ta-r">{{ heure(b.pretAt) }}</td>
                                            <td class="ta-r">{{ heure(b.notifieAt) }}</td>
                                            <td class="ta-r">
                                                <span v-if="b.vuAt">{{ heure(b.vuAt) }}</span>
                                                <span v-else class="cui-jamais">jamais</span>
                                            </td>
                                            <td class="ta-r">{{ duree(b.notifieAt, b.vuAt) }}</td>
                                            <td>
                                                <span :class="['cui-badge', b.statut === 'annule' ? 'bd-red' : 'bd-green']">
                                                    {{ b.statut === 'annule' ? 'Annulée' : 'Servie' }}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr v-if="!pageHistorique.length">
                                            <td colspan="14" class="cui-td-vide">
                                                <i class="ri-inbox-line"></i> Aucun bon sur la période sélectionnée
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div v-if="pdv.total > pageTaille" class="cui-pager">
                                <button class="cui-btn" :disabled="page === 1" @click="page--">
                                    <i class="ri-arrow-left-s-line"></i> Précédent
                                </button>
                                <span>Page {{ page }} / {{ nbPages }} &middot; {{ pdv.total }} bons</span>
                                <button class="cui-btn" :disabled="page >= nbPages" @click="page++">
                                    Suivant <i class="ri-arrow-right-s-line"></i>
                                </button>
                            </div>
                        </div>

                        <!-- ══════════════════════════════════════════════════
                             ONGLET ANALYSE DE PERFORMANCE
                        ══════════════════════════════════════════════════ -->
                        <div v-show="onglet === 'performance'" class="cui-perf">

                            <div class="cui-filtres">
                                <div class="cui-presets">
                                    <button v-for="p in PRESETS" :key="'p' + p.code"
                                            :class="['cui-preset', { on: preset === p.code }]"
                                            @click="appliquerPreset(p.code)">{{ p.libelle }}</button>
                                </div>
                                <div class="cui-filtre-grp">
                                    <label>Du</label>
                                    <input type="date" v-model="dateDebut" @change="preset = 'perso'" class="cui-input" />
                                    <label>au</label>
                                    <input type="date" v-model="dateFin" @change="preset = 'perso'" class="cui-input" />
                                </div>
                                <div class="cui-filtre-grp">
                                    <select v-model="filtreServeur" class="cui-input">
                                        <option value="">Tous les serveurs</option>
                                        <option v-for="s in serveursDisponibles" :key="'ps' + s.pid" :value="s.pid">{{ s.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <!-- Indicateurs de pilotage -->
                            <div class="cui-kpis cui-kpis-6">
                                <div class="cui-kpi">
                                    <span class="cui-kpi-l">Cycle complet moyen</span>
                                    <strong>{{ perf.cycle }}</strong>
                                    <em>réception &rarr; enlèvement</em>
                                </div>
                                <div class="cui-kpi">
                                    <span class="cui-kpi-l">Attente avant démarrage</span>
                                    <strong>{{ perf.attente }}</strong>
                                    <em>{{ ui.attente }}</em>
                                </div>
                                <div class="cui-kpi">
                                    <span class="cui-kpi-l">Temps de préparation</span>
                                    <strong>{{ perf.prep }}</strong>
                                    <em>démarrage &rarr; prêt</em>
                                </div>
                                <div class="cui-kpi">
                                    <span class="cui-kpi-l">Réponse des serveurs</span>
                                    <strong>{{ perf.reponse }}</strong>
                                    <em>notifié &rarr; acquitté</em>
                                </div>
                                <div class="cui-kpi">
                                    <span class="cui-kpi-l">Attente au passe</span>
                                    <strong>{{ perf.passe }}</strong>
                                    <em>prêt &rarr; enlevé</em>
                                </div>
                                <div class="cui-kpi" :class="perf.tauxNum >= 80 ? 'cui-kpi-ok' : 'cui-kpi-warn'">
                                    <span class="cui-kpi-l">Objectif tenu</span>
                                    <strong>{{ perf.taux }}</strong>
                                    <em>{{ perf.retards }} bon(s) en retard</em>
                                </div>
                            </div>

                            <!-- Où part le temps -->
                            <div class="cui-box">
                                <div class="cui-box-h">
                                    <span><i class="ri-stack-line"></i> Où part le temps</span>
                                    <small>Décomposition du cycle, par jour - identifie si le retard vient de la file, de la cuisson ou de la salle</small>
                                </div>
                                <apexchart v-if="chartCycle" type="bar" height="290"
                                           :options="chartCycle.options" :series="chartCycle.series"></apexchart>
                            </div>

                            <div class="cui-grid2">
                                <!-- Le classement le plus actionnable -->
                                <div class="cui-box">
                                    <div class="cui-box-h">
                                        <span><i class="ri-restaurant-line"></i> Écart à l'objectif par plat</span>
                                        <small>Les plats du haut sont ceux à revoir (recette, mise en place, ordre de lancement)</small>
                                    </div>
                                    <apexchart v-if="chartPlats" type="bar" height="330"
                                               :options="chartPlats.options" :series="chartPlats.series"></apexchart>
                                </div>

                                <!-- Le coup de feu -->
                                <div class="cui-box">
                                    <div class="cui-box-h">
                                        <span><i class="ri-line-chart-line"></i> Charge et délai par tranche horaire</span>
                                        <small>Là où la courbe décroche, il manque du monde - pas de la méthode</small>
                                    </div>
                                    <apexchart v-if="chartHeures" type="line" height="330"
                                               :options="chartHeures.options" :series="chartHeures.series"></apexchart>
                                </div>
                            </div>

                            <!-- Réactivité de la salle -->
                            <div class="cui-box">
                                <div class="cui-box-h">
                                    <span><i class="ri-user-star-line"></i> Réactivité des serveurs</span>
                                    <small>Délai entre la notification « plat prêt » et son acquittement sur le téléphone</small>
                                </div>
                                <div class="cui-table-wrap cui-table-plain">
                                    <table class="cui-table">
                                        <thead>
                                            <tr>
                                                <th>Serveur</th>
                                                <th class="ta-r">Bons notifiés</th>
                                                <th class="ta-r">Acquittés</th>
                                                <th class="ta-r">Jamais vus</th>
                                                <th class="ta-r">Réponse moyenne</th>
                                                <th class="ta-r">Enlèvement moyen</th>
                                                <th>Réactivité</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="s in perfServeurs" :key="s.pid">
                                                <td class="cui-td-num">{{ s.name }}</td>
                                                <td class="ta-r">{{ s.notifies }}</td>
                                                <td class="ta-r">{{ s.acquittes }}</td>
                                                <td class="ta-r">
                                                    <span :class="{ 'cui-jamais': s.jamais > 0 }">{{ s.jamais }}</span>
                                                </td>
                                                <td class="ta-r">{{ s.reponse }}</td>
                                                <td class="ta-r">{{ s.enlevement }}</td>
                                                <td>
                                                    <div class="cui-mini-bar">
                                                        <div :style="{ width: s.score + '%' }"
                                                             :class="s.score >= 70 ? 'mb-ok' : (s.score >= 40 ? 'mb-mid' : 'mb-ko')"></div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="perfServeurs.length === 0">
                                                <td colspan="7" class="cui-td-vide">
                                                    <i class="ri-inbox-line"></i> Aucune donnée sur la période
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <!-- ══════════════════════════════════════════════════
                             ONGLET TRAÇABILITÉ - parcours détaillé d'un bon
                        ══════════════════════════════════════════════════ -->
                        <div v-show="onglet === 'tracabilite'" class="cui-trac">

                            <div class="cui-filtres">
                                <div class="cui-presets">
                                    <button v-for="p in PRESETS" :key="'t' + p.code"
                                            :class="['cui-preset', { on: preset === p.code }]"
                                            @click="appliquerPreset(p.code)">{{ p.libelle }}</button>
                                </div>
                                <div class="cui-filtre-grp">
                                    <input v-model="rechercheTrac" class="cui-input cui-input-lg"
                                           placeholder="N° bon, commande, serveur, table…" />
                                </div>
                                <label class="cui-check">
                                    <input type="checkbox" v-model="seulementRetours" />
                                    <span>Uniquement les bons avec retour</span>
                                </label>
                            </div>

                            <div class="cui-trac-split">

                                <!-- Liste des bons -->
                                <div class="cui-box cui-trac-liste">
                                    <div class="cui-box-h">
                                        <span><i class="ri-list-check-2"></i> Bons de la période</span>
                                        <small>{{ bonsTracables.length }} bon(s) · {{ nbRetoursPeriode }} retour(s)</small>
                                    </div>
                                    <div class="cui-trac-scroll">
                                        <button v-for="b in bonsTracables" :key="'tl' + b.id"
                                                :class="['cui-trac-row', { on: bonSelectionne && bonSelectionne.id === b.id }]"
                                                @click="bonSelectionne = b">
                                            <div class="cui-trac-row-l1">
                                                <span class="cui-trac-num">{{ b.numeroBon }}</span>
                                                <span class="cui-trac-h">{{ heure(b.recuAt) }}</span>
                                                <span v-if="nbRetours(b) > 0" class="cui-trac-badge">
                                                    <i class="ri-arrow-go-back-line"></i> {{ nbRetours(b) }}
                                                </span>
                                            </div>
                                            <div class="cui-trac-row-l2">
                                                {{ b.table.name }} · {{ b.serveur.name }} · {{ jour(b.recuAt) }}
                                            </div>
                                        </button>
                                        <div v-if="bonsTracables.length === 0" class="cui-vide">
                                            <i class="ri-inbox-line"></i><span>Aucun bon</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Parcours du bon sélectionné -->
                                <div class="cui-box cui-trac-detail">
                                    <div v-if="!bonSelectionne" class="cui-vide cui-vide-lg">
                                        <i class="ri-route-line"></i>
                                        <span>Sélectionnez un bon pour voir son parcours</span>
                                    </div>

                                    <template v-else>
                                        <div class="cui-box-h">
                                            <span>
                                                <i class="ri-route-line"></i>
                                                Parcours de {{ bonSelectionne.numeroBon }}
                                            </span>
                                            <small>
                                                Cmd {{ bonSelectionne.numeroCommande }} ·
                                                Srv {{ bonSelectionne.numeroServeur }} ·
                                                {{ bonSelectionne.table.name }} ·
                                                {{ bonSelectionne.serveur.name }} ·
                                                {{ bonSelectionne.caisse.name }}
                                            </small>
                                        </div>

                                        <!-- Résumé -->
                                        <div class="cui-trac-resume">
                                            <div><span>Objectif</span><strong>{{ bonSelectionne.objectif }} min</strong></div>
                                            <div><span>Cycle réel</span><strong>{{ duree(bonSelectionne.recuAt, bonSelectionne.serviAt) }}</strong></div>
                                            <div><span>Étapes</span><strong>{{ parcours.length }}</strong></div>
                                            <div :class="{ 'res-warn': nbRetours(bonSelectionne) > 0 }">
                                                <span>Retours</span><strong>{{ nbRetours(bonSelectionne) }}</strong>
                                            </div>
                                        </div>

                                        <!-- Frise verticale -->
                                        <ol class="cui-frise">
                                            <li v-for="(e, i) in parcours" :key="'ev' + i" :class="'fr-' + e.type">
                                                <span class="cui-frise-pt"><i :class="e.icone"></i></span>
                                                <div class="cui-frise-body">
                                                    <div class="cui-frise-l1">
                                                        <strong>{{ e.libelle }}</strong>
                                                        <span class="cui-frise-h">{{ heure(e.at) }}</span>
                                                    </div>
                                                    <div class="cui-frise-l2">
                                                        <span v-if="e.detail">{{ e.detail }}</span>
                                                        <span v-if="i > 0" class="cui-frise-delta">
                                                            +{{ duree(parcours[i - 1].at, e.at) }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </li>
                                        </ol>

                                        <!-- Contenu du bon, pour situer -->
                                        <div class="cui-trac-plats">
                                            <span class="cui-trac-plats-t">Contenu du bon</span>
                                            <span v-for="l in bonSelectionne.lignes" :key="'tp' + l.id" class="cui-tag">
                                                {{ l.qte }}× {{ l.nom }}
                                                <em v-if="l.accompagnement"> + {{ l.accompagnement }}</em>
                                            </span>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>

                        <!-- ══════════ PIED ══════════
                             La barre de démonstration a été retirée : l'écran ne
                             tourne plus sur des données simulées. Ne subsiste que
                             l'information matérielle, utile au réglage du poste. -->
                        <div v-if="!vibrationDispo" class="cui-pied">
                            <i class="ri-information-line"></i>
                            <span>
                                Cet appareil ne gère pas la vibration - l'alerte d'arrivée
                                se fera uniquement au son.
                            </span>
                        </div>

                    </div>
                </div>
            </div>

        </template>
    </templatesite>

</template>

<script>
/* eslint-disable */
import templatesite from "@/components/template/apptemplate";
import appheader from "@/components/template/appheader";
import appsidebar from "@/components/template/appsidebar";
import VueApexCharts from "vue3-apexcharts";
const axios = require("axios");
import * as JwtService from "@/common/jwt.service";
import { randomString } from "@/allfunction";
import { ScangoSocket } from "@/service/scangosocket";

/* Étapes du flux de production. Définies ici et non dans un fichier de données :
   ce n'est pas un jeu d'essai, c'est la structure même du kanban. L'ordre du
   tableau EST l'ordre du flux.
   ⚠️ `mocks.js` n'est plus importé - l'écran ne tourne plus sur des données
   simulées. Le fichier subsiste sur le disque mais n'est plus référencé. */
const ETAPES = [
    { code: "recu",        libelle: "Reçues",          icone: "ri-inbox-archive-line",   couleur: "#3b82f6" },
    { code: "preparation", libelle: "En préparation",  icone: "ri-fire-line",            couleur: "#f59e0b" },
    { code: "pret",        libelle: "Prêtes",          icone: "ri-checkbox-circle-line", couleur: "#10b981" },
    { code: "servi",       libelle: "Servies",         icone: "ri-check-double-line",    couleur: "#64748b" },
];

/* Module `screen` du backend. Routes protégées : le btkpid vient de la session
   de l'écran, jamais du corps - un code ne traverse pas les sociétés. */
const BASE_SCREEN = "/egl745874pscreen771714dfe";

/* Le jeton d'appairage doit survivre au rechargement, sinon l'écran redemande
   un code à chaque F5 et chaque matin. localStorage suffit : c'est un
   identifiant de connexion, pas une donnée métier - pas d'IndexedDB ici. */
/* Tout ce qui distingue un poste d'un autre est ICI, et nulle part ailleurs.
   Le reste du composant (appairage, socket, kanban, analytique, traçabilité) est
   strictement commun : c'est la raison d'être de ce fichier, partagé par les
   pages /cuisine et /bar.

   ⚠️ La clé de la cuisine ne doit JAMAIS changer : un écran déjà appairé y garde
   son jeton, et le renommer forcerait tout le parc à ressaisir un code. */
const HABILLAGE = {
    cuisine: {
        cle: "screen_cuisine_jeton_v1",
        titre: "CUISINE",
        icone: "ri-restaurant-2-fill",
        libelleDefaut: "Écran cuisine",
        recu: "Bon reçu en cuisine",
        annule: "Étape annulée à la cuisine",
        entree: "Cuisine",
        attente: "file d'attente cuisine",
        replicaisse: "Cuisine",
        trace: "cuisine",
    },
    bar: {
        cle: "screen_bar_jeton_v1",
        titre: "BAR",
        icone: "ri-goblet-2-fill",
        libelleDefaut: "Écran bar",
        recu: "Bon reçu au bar",
        annule: "Étape annulée au bar",
        entree: "Bar",
        attente: "file d'attente bar",
        replicaisse: "Bar",
        trace: "bar",
    },
};

const PRESETS = [
    { code: "jour", libelle: "Aujourd'hui" },
    { code: "hier", libelle: "Hier" },
    { code: "7j",   libelle: "7 jours" },
    { code: "30j",  libelle: "30 jours" },
];

/* Part de l'objectif à partir de laquelle on passe en alerte. */
const SEUIL_ORANGE = 0.75;

/* Intervalle de relance sonore tant qu'un bon reçu n'est pas pris en compte. */
const RELANCE_MS = 30000;

const iso = (d) => {
    const p = (n) => String(n).padStart(2, "0");
    return d.getFullYear() + "-" + p(d.getMonth() + 1) + "-" + p(d.getDate());
};

/* Minutes écoulées entre deux instants ISO ; null si l'un manque. */
const ecart = (a, b) => (a && b ? (new Date(b) - new Date(a)) / 60000 : null);

const moyenne = (vals) => (vals.length ? vals.reduce((s, v) => s + v, 0) / vals.length : null);

const fmtMin = (m) => (m === null || m === undefined ? "-" : (m < 1 ? "< 1 min" : Math.round(m) + " min"));

export default {
    name: "ecranproduction",

    /* Le poste est imposé par la page qui monte ce composant (/cuisine ou /bar),
       jamais deviné : deux écrans peuvent cohabiter dans le même navigateur, et
       chacun doit retrouver SON jeton. */
    props: {
        poste: {
            type: String,
            default: "cuisine",
            validator: (v) => v === "cuisine" || v === "bar",
        },
    },
    components: { templatesite, appheader, appsidebar, apexchart: VueApexCharts },

    data() {
        return {
            ETAPES, PRESETS,

            onglet: "service",
            pleinEcran: false,

            /* Alerte d'arrivée : son + vibration. */
            alerteActive: true,
            vibrationDispo: false,

            etatRoom: "horsligne",
            roomCaisse: "",
            codeSaisi: "",
            erreurRoom: "",

            /* Appairage réel (module `screen`). */
            jeton: "",
            ecran: null,              // fiche renvoyée par le backend
            parametrageScreen: null,  // postes + durées
            jetonExpireAt: null,      // ISO
            jetonReste: 0,            // secondes, décomptées localement
            rtConnecte: false,        // socket temps réel de l'écran
            decalageHorloge: 0,       // serverNow - Date.now(), l'horloge du poste dérive

            bons: [],
            dernierRecu: "",
            lignesFaites: {},

            /* Horloge locale : une seule référence réactive rafraîchie chaque
               seconde, plutôt qu'un Date.now() par carte à chaque rendu. */
            maintenant: Date.now(),

            tousLesBons: [],
            preset: "jour",
            dateDebut: iso(new Date()),
            dateFin: iso(new Date()),
            filtreServeur: "",
            filtreCaisse: "",
            filtreStatut: "",
            page: 1,
            pageTaille: 25,

            /* Données analytiques venues du backend (agrégations SQL). */
            pdv: { bons: [], kpi: {}, total: 0, taille: 25 },
            perfSrv: { indicateurs: {}, parJour: [], parPlat: [], parHeure: [], parServeur: [] },
            chargementPdv: false,
            chargementPerf: false,

            chartCycle: null,
            chartPlats: null,
            chartHeures: null,

            /* Traçabilité */
            bonSelectionne: null,
            rechercheTrac: "",
            seulementRetours: false,
        };
    },

    computed: {
        /* Habillage du poste courant. Tout le template y puise ses libellés, ce
           qui évite un v-if par texte. */
        ui() {
            return HABILLAGE[this.poste] || HABILLAGE.cuisine;
        },

        dateDuJour() {
            return new Date().toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long" });
        },

        libelleEtatRoom() {
            if (this.etatRoom === "connecte") return this.roomCaisse || "Connecté";
            if (this.etatRoom === "connexion") return "Connexion…";
            return "Hors ligne";
        },

        /* Durée restante du jeton, en unité lisible : personne ne compte en
           secondes à trois semaines d'échéance. */
        resteJeton() {
            const s = this.jetonReste;
            if (s <= 0) return "expiré";
            const j = Math.floor(s / 86400);
            if (j >= 2) return "encore " + j + " jours";
            const h = Math.floor(s / 3600);
            if (h >= 2) return "encore " + h + " h";
            const m = Math.floor(s / 60);
            if (m >= 1) return "encore " + m + " min";
            return "moins d'une minute";
        },

        /* Trois jours d'avance pour prévenir : le temps qu'un responsable passe
           à la caisse générer un nouveau code. */
        urgenceJeton() {
            if (this.jetonReste <= 0) return "mort";
            if (this.jetonReste <= 3 * 86400) return "fin";
            return "ok";
        },

        nbActifs() {
            return this.bons.filter((b) => b.statut === "recu" || b.statut === "preparation").length;
        },

        /* Listes de filtres déduites des bons réellement chargés, et non d'un
           référentiel figé : le jour où le backend enverra des bons, les menus
           déroulants se peupleront tout seuls. Vides tant qu'il n'y a rien. */
        serveursDisponibles() {
            const m = new Map();
            for (const b of this.pdv.bons) {
                if (b.serveur && b.serveur.pid) m.set(String(b.serveur.pid), b.serveur.name || b.serveur.pid);
            }
            return Array.from(m, ([pid, name]) => ({ pid, name })).sort((a, b) => a.name.localeCompare(b.name));
        },

        caissesDisponibles() {
            const m = new Map();
            for (const b of this.pdv.bons) {
                if (b.caisse && b.caisse.pid) m.set(String(b.caisse.pid), b.caisse.name || b.caisse.pid);
            }
            return Array.from(m, ([pid, name]) => ({ pid, name })).sort((a, b) => a.name.localeCompare(b.name));
        },

        /* ── Onglets analytiques : alimentés par le BACKEND (agrégations SQL) ──
           Plus de calcul depuis des mocks. pdv = Point de ventes, perfSrv =
           Performance. Les computed ci-dessous ne font que présenter. */

        pageHistorique() { return this.pdv.bons || []; },

        nbPages() {
            return Math.max(1, Math.ceil((this.pdv.total || 0) / (this.pdv.taille || this.pageTaille)));
        },

        kpi() {
            const k = this.pdv.kpi || {};
            return {
                bons: k.bons || 0,
                plats: k.plats || 0,
                delaiPrep: k.delaiPrep != null ? k.delaiPrep + " min" : "-",
                delaiServi: k.delaiServi != null ? k.delaiServi + " min" : "-",
            };
        },

        perf() {
            const i = this.perfSrv.indicateurs || {};
            const m = (v) => (v == null ? "-" : v + " min");
            return {
                cycle: m(i.cycle), attente: m(i.attente), prep: m(i.prep),
                reponse: m(i.reponse), passe: m(i.passe),
                taux: i.tauxTenu == null ? "-" : i.tauxTenu + " %",
                tauxNum: i.tauxTenu || 0,
                retards: i.retards || 0,
            };
        },

        perfServeurs() {
            return (this.perfSrv.parServeur || []).map((e) => {
                const base = e.reponse == null ? 0 : Math.max(0, 100 - e.reponse * 10);
                const penalite = e.notifies ? (e.jamais / e.notifies) * 100 : 0;
                return {
                    ...e,
                    reponse: e.reponse == null ? "-" : e.reponse + " min",
                    enlevement: e.enlevement == null ? "-" : e.enlevement + " min",
                    score: Math.round(Math.max(0, base - penalite)),
                };
            });
        },

        /* ══════════ Traçabilité ══════════ */

        /* Bons de la période (backend) + ceux du service en cours (kanban local). */
        bonsTracables() {
            const vus = new Set();
            const base = [];
            /* Les bons du backend portent un id texte, ceux du kanban local un id
               numérique : sans normalisation, un bon du service en cours
               apparaîtrait DEUX fois. Le backend passe en premier - c'est lui qui
               porte le journal réel des étapes. */
            for (const b of (this.pdv.bons || []).concat(this.bons)) {
                const cle = String(b.id);
                if (vus.has(cle)) continue;
                vus.add(cle);
                base.push(b);
            }
            const q = this.rechercheTrac.trim().toLowerCase();
            return base
                .filter((b) => {
                    if (this.seulementRetours && this.nbRetours(b) === 0) return false;
                    if (!q) return true;
                    return [b.numeroBon, b.numeroCommande, b.numeroServeur, b.serveur.name, b.table.name]
                        .some((v) => String(v).toLowerCase().includes(q));
                })
                .sort((a, b) => new Date(b.recuAt) - new Date(a.recuAt))
                .slice(0, 200);
        },

        nbRetoursPeriode() {
            let n = 0;
            for (const b of this.bonsTracables) n += this.nbRetours(b);
            return n;
        },

        /* Frise du bon sélectionné : le journal des étapes, enrichi des
           événements de notification qui n'en font pas partie (notifié, vu)
           mais qui appartiennent au même récit. Le tout remis en ordre. */
        parcours() {
            const b = this.bonSelectionne;
            if (!b) return [];

            const ev = [{
                at: b.recuAt, type: "reception", icone: "ri-inbox-archive-line",
                libelle: this.ui.recu,
                detail: this.nbPlats(b) + " plat(s) · objectif " + b.objectif + " min",
            }];

            for (const j of (b.journal || [])) {
                const retour = j.sens === "retour";
                ev.push({
                    at: j.at,
                    type: retour ? "retour" : "avant",
                    icone: retour ? "ri-arrow-go-back-line" : "ri-arrow-right-line",
                    libelle: (retour ? "Retour : " : "") + this.libelleEtape(j.de) + " → " + this.libelleEtape(j.vers),
                    detail: retour ? this.ui.annule : "",
                });
            }

            if (b.notifieAt) {
                ev.push({
                    at: b.notifieAt, type: "notif", icone: "ri-send-plane-line",
                    libelle: "Serveur et caisse notifiés",
                    detail: (b.notifies || []).join(" · "),
                });
            }
            if (b.vuAt) {
                ev.push({
                    at: b.vuAt, type: "vu", icone: "ri-eye-line",
                    libelle: "Acquitté par " + b.serveur.name, detail: "",
                });
            }

            return ev.sort((x, y) => new Date(x.at) - new Date(y.at));
        },
    },

    watch: {
        /* Un changement de filtre repart en page 1 et recharge l'onglet actif. */
        dateDebut() { this.page = 1; this.rechargerAnalytique(); },
        dateFin() { this.page = 1; this.rechargerAnalytique(); },
        filtreServeur() { this.page = 1; this.rechargerAnalytique(); },
        filtreCaisse() { this.page = 1; this.rechargerAnalytique(); },
        filtreStatut() { this.page = 1; this.rechargerAnalytique(); },
        page() { if (this.onglet === "historique") this.chargerPointDeVentes(); },
        /* À l'ouverture d'un onglet analytique, on charge s'il est vide. */
        onglet(v) {
            if (v === "historique" && !(this.pdv.bons || []).length) this.chargerPointDeVentes();
            if (v === "tracabilite" && !(this.pdv.bons || []).length) this.chargerPointDeVentes();
            if (v === "performance" && !(this.perfSrv.parJour || []).length) this.chargerPerformance();
        },
    },

    methods: {
        /* ══════════ Connexion à la room ══════════ */

        _headers() {
            return {
                "X-Requested-With": "XMLHttpRequest",
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + JwtService.getToken(),
                csrftoken: this.$store.state.appsociete,
            };
        },

        _url(chemin) {
            return process.env.VUE_APP_API_URL + BASE_SCREEN + chemin + "/" + randomString(120);
        },

        /* Signalement d'appareil, transmis dans le bloc meta. Purement descriptif :
           il aide le caissier à reconnaître l'écran dans la liste. */
        _meta() {
            return {
                poste: this.poste,
                ecran: (typeof screen !== "undefined") ? screen.width + "×" + screen.height : "",
                agent: String(navigator.userAgent || "").slice(0, 180),
                langue: navigator.language || "",
                vibration: this.vibrationDispo,
            };
        },

        /* Codes de refus du backend : jamais affichés bruts, ils sont faits pour
           les logs. Le message montré parle au personnel de salle. */
        _messageRefus(code) {
            const M = {
                SESSION_INVALID: "Session expirée. Reconnectez-vous à l'application.",
                PARAMS_INVALID: "Requête incomplète. Actualisez la page.",
                CODE_INVALID: "Code inconnu. Vérifiez la saisie, ou demandez-en un nouveau à la caisse.",
                CODE_EXPIRED: "Ce code a expiré. Demandez-en un nouveau à la caisse.",
                JETON_INVALID: "Cet écran n'est plus reconnu. Demandez un nouveau code.",
                JETON_EXPIRED: "L'autorisation de cet écran a expiré. Demandez un nouveau code.",
                JETON_REVOQUE: "Cet écran a été débranché depuis la caisse.",
                /* Quota d'écrans, contrôlé une seconde fois au moment où le code
                   devient un jeton : une autre caisse a pu prendre la dernière
                   place entre-temps. Le code n'est PAS consommé, il reste
                   saisissable une fois qu'une place se libère. */
                SCREEN_NON_LICENCIE: "Votre licence ne couvre pas les écrans de production.",
                SCREEN_QUOTA_ATTEINT: "Toutes les autorisations d'écran sont utilisées. Débranchez un écran depuis la caisse, puis ressaisissez ce code.",
                /* Un écran de ce type est déjà EN LIGNE. On refuse le rattachement
                   pour ne pas lui voler l'état de ses préparations en cours. */
                ECRAN_DEJA_CONNECTE: "Un écran de ce poste est déjà connecté et en service. Déconnectez-le d'abord, ou débranchez-le depuis la caisse.",
            };
            return M[code] || "Connexion impossible pour le moment.";
        },

        /** Échange le code saisi contre le jeton durable. */
        async connecter() {
            const code = this.codeSaisi.trim();
            if (code.length < 4) return;
            this.erreurRoom = "";
            this.etatRoom = "connexion";
            try {
                const { data } = await axios.post(
                    this._url("/ecran/othetdskd8755dsdhisd/cuisine/connexion"),
                    { code, libelle: this.libelleEcran(), meta: this._meta() },
                    { headers: this._headers(), withCredentials: true }
                );
                if (!data.success) {
                    this.etatRoom = "horsligne";
                    this.erreurRoom = this._messageRefus(data.m && data.m.code);
                    return;
                }
                this.jeton = data.m.jeton;
                try { localStorage.setItem(this.ui.cle, this.jeton); } catch (e) { /* mode privé */ }
                this._appliquerEtat(data.m);
                this.codeSaisi = "";
                this.demarrerBattement();
                this.connecterTempsReel();
                /* Un écran hors ligne du même poste a été délié pour laisser la
                   place : on le dit clairement plutôt que de le taire. */
                if (data.m.remplacement) {
                    toastr["info"](
                        "Un écran " + (this.ecran ? this.ecran.posteLibelle : "de ce poste") +
                        " était déjà lié (hors ligne). Il a été délié - celui-ci prend sa place.",
                        "<b></b>"
                    );
                } else {
                    toastr["success"]("Écran rattaché à la caisse.", "<b></b>");
                }
            } catch (e) {
                this.etatRoom = "horsligne";
                this.erreurRoom = "Le serveur ne répond pas. Vérifiez le réseau.";
                console.error("[screen] connexion", e);
            }
        },

        /** Nom par défaut de l'écran, modifiable côté caisse. */
        libelleEcran() {
            return this.ui.libelleDefaut;
        },

        /**
         * Battement de cœur : signale que l'écran est vivant, et sert de reprise
         * de session au démarrage. C'est ce qui allume le voyant côté caisse.
         */
        async battre(silencieux) {
            if (!this.jeton) return false;
            try {
                const { data } = await axios.post(
                    this._url("/ecran/othetdskd8755dsdhisd/cuisine/battement"),
                    { jeton: this.jeton, meta: this._meta() },
                    { headers: this._headers(), withCredentials: true }
                );
                if (!data.success) {
                    /* Jeton mort : on le jette, l'écran redemande un code. Le
                       garder ferait boucler le battement sur un refus. */
                    this.oublierJeton();
                    this.erreurRoom = this._messageRefus(data.m && data.m.code);
                    try { localStorage.removeItem(this.ui.cle); } catch (e) { /* ignore */ }
        
                    return false;
                }
                this._appliquerEtat(data.m);
                return true;
            } catch (e) {
                /* Coupure réseau : on NE jette PAS le jeton, il redeviendra
                   valable au retour. On bascule seulement le voyant. */
                this.etatRoom = "horsligne";
                if (!silencieux) this.erreurRoom = "Connexion au serveur perdue.";
                return false;
            }
        },

        /** Applique une réponse de connexion ou de battement. */
        _appliquerEtat(m) {
            this.ecran = m.ecran || null;
            this.parametrageScreen = m.parametrage || this.parametrageScreen;
            if (typeof m.serverNow === "number") this.decalageHorloge = m.serverNow - Date.now();
            if (this.ecran) {
                this.jetonExpireAt = this.ecran.jetonExpireAt || null;
                this.jetonReste = this.ecran.jetonSecondesRestantes || 0;
                this.roomCaisse = (this.ecran.libelle || this.ecran.posteLibelle || this.ui.replicaisse);
            }
            const etaitConnecte = this.etatRoom === "connecte";
            this.etatRoom = "connecte";
            this.erreurRoom = "";
            /* Première connexion : si un onglet analytique est déjà ouvert, on le
               charge maintenant qu'on a une session écran valide. */
            if (!etaitConnecte && this.onglet !== "service") this.rechargerAnalytique();
        },

        /* ══════════ Canal temps réel ══════════
           C'est la connexion socket qui fait foi pour la présence : tant qu'elle
           tient, la caisse voit l'écran en ligne, sans une seule requête SQL.
           Le battement HTTP n'est plus un sondage de présence - il ne sert qu'à
           renouveler l'état du jeton, à un rythme très lent. */

        connecterTempsReel() {
            if (!this.jeton || !this.ecran || !this.ecran.room) return;
            this.deconnecterTempsReel();
            this._sock = new ScangoSocket();
            this._sock.connecter(
                { room: this.ecran.room, token: this.jeton, role: this.ecran.poste },
                {
                    onConnect: () => {
                        this.rtConnecte = true;
                        /* Rattrapage : tout ce qui est arrivé pendant que l'écran
                           était éteint ou coupé. Remplace un cache local. */
                        this.rattraperBons();
                    },
                    onRefus: (code) => {
                        this.rtConnecte = false;
                        /* Refus définitif du canal = jeton mort. On le jette pour
                           que l'écran redemande un code, au lieu de boucler. */
                        this.oublierJeton();
                        this.erreurRoom = this._messageRefus(
                            String(code || "").replace("SCREEN_", "JETON_")
                        );
                    },
                    onCoupure: () => { this.rtConnecte = false; },
                }
            );
            this._sock.sur("bon", (b) => this.recevoirBon(b));
        },

        deconnecterTempsReel() {
            if (this._sock) { this._sock.deconnecter(); this._sock = null; }
            this.rtConnecte = false;
        },

        /** Un bon arrive de la caisse. */
        recevoirBon(b) {
            if (!b || !b.id) return;
            const i = this.bons.findIndex((x) => String(x.id) === String(b.id));
            if (i >= 0) { this.bons.splice(i, 1, b); return; }   // re-diffusion
            this.bons.unshift(b);
            this.tousLesBons.unshift(b);
            this.dernierRecu = b.id;
            this.onglet = "service";
            this.alerter(true);
            setTimeout(() => { if (this.dernierRecu === b.id) this.dernierRecu = ""; }, 6000);
        },

        /** Bons encore à traiter, redemandés au backend à chaque connexion. */
        async rattraperBons() {
            if (!this.ecran) return;
            try {
                const { data } = await axios.post(
                    this._url("/ecran/othetdskd8755dsdhisd/cuisine/bonsouverts"),
                    /* L'écran s'identifie par son jeton : le backend en déduit
                       l'écran, le poste et la caisse - rien n'est cru sur parole. */
                    { jeton: this.jeton },
                    { headers: this._headers(), withCredentials: true }
                );
                if (!data.success || !data.m) return;
                const recus = data.m.bons || [];
                /* Fusion par identifiant : un bon déjà présent n'est pas dupliqué,
                   et son état local (étape en cours) n'est pas écrasé. */
                const connus = new Set(this.bons.map((x) => String(x.id)));
                const nouveaux = recus.filter((x) => !connus.has(String(x.id)));
                if (nouveaux.length) {
                    this.bons = nouveaux.concat(this.bons);
                    this.tousLesBons = nouveaux.concat(this.tousLesBons);
                    this.alerter(true);
                }
            } catch (e) {
                console.warn("[screen] rattrapage impossible", e && (e.message || e));
            }
        },

        /* Renouvellement de l'état du jeton. Très espacé (10 min) : la présence
           ne dépend plus de lui, il ne fait que rafraîchir l'échéance affichée. */
        demarrerBattement() {
            this.arreterBattement();
            this._battement = setInterval(() => this.battre(true), 600000);
        },

        arreterBattement() {
            if (this._battement) { clearInterval(this._battement); this._battement = null; }
        },

        oublierJeton() {
            this.arreterBattement();
            this.deconnecterTempsReel();
            this.jeton = "";
            this.ecran = null;
            this.jetonExpireAt = null;
            this.jetonReste = 0;
            this.roomCaisse = "";
            this.etatRoom = "horsligne";
           // try { localStorage.removeItem(this.ui.cle); } catch (e) { /* ignore */ }
        
        },

        /* Reprise au démarrage : si un jeton dort en local, un seul battement
           suffit à retrouver la connexion - aucun code à ressaisir. */
        async reprendreSession() {
            let stocke = "";
            try { stocke = localStorage.getItem(this.ui.cle) || ""; } catch (e) { stocke = ""; }
            if (!stocke) return;
            this.jeton = stocke;
            this.etatRoom = "connexion";
            const ok = await this.battre(true);
            if (ok) { this.demarrerBattement(); this.connecterTempsReel(); }
            else this.etatRoom = "horsligne";
        },

        basculerConnexion() {
            if (this.etatRoom === "connecte") {
                this.oublierJeton();
                toastr["info"]("Écran détaché. Saisissez un code pour vous reconnecter.", "<b></b>");
                return;
            }
            this.onglet = "service";
        },

        /* ══════════ Kanban ══════════ */

        parEtape(code) {
            return this.bons
                .filter((b) => b.statut === code)
                .sort((a, b) => new Date(a.recuAt) - new Date(b.recuAt));
        },

        indexEtape(code) { return ETAPES.findIndex((e) => e.code === code); },
        etapeSuivante(code) { const i = this.indexEtape(code); return i >= 0 && i < ETAPES.length - 1 ? ETAPES[i + 1].code : null; },
        etapePrecedente(code) { const i = this.indexEtape(code); return i > 0 ? ETAPES[i - 1].code : null; },
        libelleEtape(code) { const e = ETAPES.find((x) => x.code === code); return e ? e.libelle : code; },
        couleurEtape(code) { const e = ETAPES.find((x) => x.code === code); return e ? e.couleur : "#64748b"; },
        libelleAction(s) { return s === "recu" ? "Commencer" : (s === "preparation" ? "Prêt" : "Servi"); },

        /* Journalise un changement d'étape. Appelé par avancer ET reculer : le
           journal est la seule mémoire fidèle du parcours, puisque les
           horodatages de tête (pretAt…) sont remis à zéro quand on recule. */
        journaliser(b, de, vers, sens) {
            if (!Array.isArray(b.journal)) b.journal = [];
            b.journal.push({ de, vers, at: new Date().toISOString(), sens });
        },

        avancer(b) {
            const suiv = this.etapeSuivante(b.statut);
            if (!suiv) return;
            const t = new Date().toISOString();
            this.journaliser(b, b.statut, suiv, "avant");
            b.statut = suiv;
            if (suiv === "preparation") b.preparationAt = t;
            if (suiv === "pret") {
                /* Trois instants distincts, et c'est volontaire :
                   pretAt   = le cuisinier a cliqué ;
                   notifieAt = la notification a été REMISE (ici immédiat, en réel
                               ce sera l'accusé du canal - il peut manquer) ;
                   vuAt     = le serveur a acquitté (viendra de son téléphone). */
                b.pretAt = t;
                b.notifieAt = t;
                b.vuAt = null;
                b.notifies = ["serveur", "caisse"];
                toastr["success"](
                    b.serveur.name + " et la caisse sont prévenus - " + b.numeroBon + " est prêt.",
                    "<b></b>"
                );
            }
            if (suiv === "servi") {
                b.serviAt = t;
                /* Enlèvement sans acquittement préalable : le serveur est venu
                   sans ouvrir la notification. On horodate quand même. */
                if (!b.vuAt) b.vuAt = t;
            }
            /* Le retour : on remonte le changement d'étape au backend, qui met à
               jour le statut du bon. Alimente la charge (dispatcher) et les
               onglets analytiques. Best-effort - le kanban local reste maître de
               l'affichage même si le socket est coupé. */
            this.remonterEtape(b, suiv);
        },

        reculer(b) {
            const prec = this.etapePrecedente(b.statut);
            if (!prec) return;
            /* Journalisé AVANT l'effacement : sans ça, un « Prêt » cliqué puis
               annulé disparaîtrait sans laisser de trace, et les mesures de
               l'onglet Performance deviendraient invérifiables. */
            this.journaliser(b, b.statut, prec, "retour");
            if (b.statut === "pret") { b.pretAt = null; b.notifieAt = null; b.vuAt = null; b.notifies = []; }
            if (b.statut === "servi") b.serviAt = null;
            if (b.statut === "preparation") b.preparationAt = null;
            b.statut = prec;
            this.remonterEtape(b, prec);
        },

        /* Remonte au backend le statut atteint par un bon. Ne concerne que les
           bons RÉELS (id numérique de screen_bons) : un bon local (démo) n'a rien
           à remonter. Best-effort : jamais bloquant. */
        remonterEtape(b, versStatut) {
            if (!b || !b.id) return;
            if (!this._sock || !this._sock.connecte || !this._sock.connecte()) return;
            this._sock.emettre("etape", { bonId: b.id, versStatut });
        },

        toutDemarrer() { for (const b of this.parEtape("recu")) this.avancer(b); },

        /* ══════════ Traçabilité ══════════ */

        nbRetours(b) {
            if (!b || !Array.isArray(b.journal)) return 0;
            return b.journal.filter((j) => j.sens === "retour").length;
        },

        ouvrirTracabilite(b) {
            this.bonSelectionne = b;
            this.onglet = "tracabilite";
            /* Le bon peut être hors période (service en cours) : on élargit pour
               qu'il apparaisse bien dans la liste de gauche. */
            if (b.recuAt.slice(0, 10) > this.dateFin || b.recuAt.slice(0, 10) < this.dateDebut) {
                this.appliquerPreset("7j");
            }
        },

        /* ══════════ Décompte ══════════ */

        enCours(b) { return b.statut === "recu" || b.statut === "preparation"; },

        /* Heure de sortie visée = réception + objectif du plat le plus long.
           On part de la RÉCEPTION et non du démarrage : le temps passé en file
           d'attente est du temps perdu pour le client, il doit peser. */
        cibleMs(b) { return new Date(b.recuAt).getTime() + b.objectif * 60000; },

        heureCible(b) {
            return new Date(this.cibleMs(b)).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
        },

        restantSec(b) { return Math.round((this.cibleMs(b) - this.maintenant) / 1000); },

        decompte(b) {
            const s = this.restantSec(b);
            const abs = Math.abs(s);
            const mm = String(Math.floor(abs / 60)).padStart(2, "0");
            const ss = String(abs % 60).padStart(2, "0");
            return (s < 0 ? "+" : "") + mm + ":" + ss;
        },

        avancement(b) {
            const total = b.objectif * 60000;
            const ecoule = this.maintenant - new Date(b.recuAt).getTime();
            return Math.min(100, Math.max(0, (ecoule / total) * 100));
        },

        urgence(b) {
            if (!this.enCours(b)) return "ok";
            const part = this.avancement(b) / 100;
            if (part >= 1) return "rouge";
            if (part >= SEUIL_ORANGE) return "orange";
            return "ok";
        },

        /* ══════════ Temps ══════════ */

        heure(v) {
            if (!v) return "-";
            return new Date(v).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
        },

        jour(v) {
            if (!v) return "-";
            return new Date(v).toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "2-digit" });
        },

        duree(a, b) { return fmtMin(ecart(a, b)); },

        dateLongue(v) {
            if (!v) return "-";
            const d = new Date(v);
            if (isNaN(d.getTime())) return "-";
            return d.toLocaleString("fr-FR", {
                weekday: "long", day: "numeric", month: "long",
                hour: "2-digit", minute: "2-digit",
            });
        },

        /* Deux origines de bons cohabitent dans les onglets analytiques :
           - le KANBAN local, qui porte le détail de ses lignes ;
           - le BACKEND (point de ventes), qui ne renvoie QUE le total `plats`,
             déjà agrégé en SQL - jamais les lignes, qui feraient des milliers
             de lignes pour rien.
           Sans ce repli, l'affichage d'un bon de la base plante. */
        nbPlats(b) {
            if (!b) return 0;
            if (!Array.isArray(b.lignes)) return Number(b.plats) || 0;
            let n = 0;
            for (const l of b.lignes) n += Number(l.qte) || 0;
            return n;
        },

        /* ══════════ Période ══════════ */

        appliquerPreset(code) {
            this.preset = code;
            const now = new Date();
            const hier = new Date(now.getTime() - 86400000);
            if (code === "jour") { this.dateDebut = iso(now); this.dateFin = iso(now); }
            if (code === "hier") { this.dateDebut = iso(hier); this.dateFin = iso(hier); }
            if (code === "7j") { this.dateDebut = iso(new Date(now.getTime() - 6 * 86400000)); this.dateFin = iso(now); }
            if (code === "30j") { this.dateDebut = iso(new Date(now.getTime() - 29 * 86400000)); this.dateFin = iso(now); }
            this.rechargerAnalytique();
        },

        /* ══════════ Chargement des données analytiques (backend) ══════════ */

        _corpsFiltres() {
            return {
                /* Chaque écran ne compte QUE ses propres bons. Sans ce filtre,
                   l'écran cuisine intégrait les bons du bar dans son Point de
                   ventes et sa Performance (défaut présent avant l'ouverture du
                   second poste, invisible tant qu'il n'y en avait qu'un). */
                poste: this.poste,
                dateDebut: this.dateDebut,
                dateFin: this.dateFin,
                serveurPid: this.filtreServeur || "",
                pidcaisse: this.filtreCaisse || "",
                statut: this.filtreStatut || "",
            };
        },

        /* Recharge l'onglet analytique ACTIF (ne sollicite pas le backend pour un
           onglet non affiché). Appelé au changement de filtre/période/page. */
        rechargerAnalytique() {
            if (this.onglet === "historique") this.chargerPointDeVentes();
            else if (this.onglet === "performance") this.chargerPerformance();
            else if (this.onglet === "tracabilite") this.chargerPointDeVentes();
        },

        async chargerPointDeVentes() {
            if (this.etatRoom !== "connecte") return;   // pas de session écran → pas d'appel
            this.chargementPdv = true;
            try {
                const { data } = await axios.post(
                    this._url("/ecran/othetdskd8755dsdhisd/cuisine/pointdeventes"),
                    { ...this._corpsFiltres(), page: this.page, taille: this.pageTaille },
                    { headers: this._headers(), withCredentials: true }
                );
                if (data.success && data.m) {
                    this.pdv = {
                        bons: data.m.bons || [], kpi: data.m.kpi || {},
                        total: data.m.total || 0, taille: data.m.taille || this.pageTaille,
                    };
                }
            } catch (e) {
                console.warn("[" + this.poste + "] point de ventes", e && (e.message || e));
            } finally { this.chargementPdv = false; }
        },

        async chargerPerformance() {
            if (this.etatRoom !== "connecte") return;
            this.chargementPerf = true;
            try {
                const { data } = await axios.post(
                    this._url("/ecran/othetdskd8755dsdhisd/cuisine/performance"),
                    this._corpsFiltres(),
                    { headers: this._headers(), withCredentials: true }
                );
                if (data.success && data.m) {
                    this.perfSrv = {
                        indicateurs: data.m.indicateurs || {},
                        parJour: data.m.parJour || [], parPlat: data.m.parPlat || [],
                        parHeure: data.m.parHeure || [], parServeur: data.m.parServeur || [],
                    };
                    this.$nextTick(() => this.construireGraphiques());
                }
            } catch (e) {
                console.warn("[" + this.poste + "] performance", e && (e.message || e));
            } finally { this.chargementPerf = false; }
        },

        /* ══════════ Analyse de performance ══════════ */

        ouvrirPerformance() {
            this.onglet = "performance";
            this.chargerPerformance();
        },

        /* Le thème sombre de l'application est porté par html.dark ; ApexCharts
           ne le voit pas tout seul. */
        modeSombre() {
            return document.documentElement.classList.contains("dark");
        },

        socleGraphique() {
            const sombre = this.modeSombre();
            return {
                chart: { toolbar: { show: false }, fontFamily: "Inter, sans-serif", background: "transparent" },
                theme: { mode: sombre ? "dark" : "light" },
                grid: { borderColor: sombre ? "rgba(148,163,184,0.18)" : "rgba(148,163,184,0.22)" },
                dataLabels: { enabled: false },
                legend: { position: "top", horizontalAlign: "left", fontSize: "12px" },
            };
        },

        construireGraphiques() {
            this.construireChartCycle();
            this.construireChartPlats();
            this.construireChartHeures();
        },

        /* Décomposition du cycle par jour : la seule vue qui dit OÙ part le temps.
           Données déjà agrégées par le backend (perfSrv.parJour). */
        construireChartCycle() {
            const src = this.perfSrv.parJour || [];
            const jours = src.map((x) => x.jour);
            const z = (v) => (v == null ? 0 : v);

            this.chartCycle = {
                series: [
                    { name: "Attente avant démarrage", data: src.map((x) => z(x.attente)) },
                    { name: "Préparation", data: src.map((x) => z(x.prep)) },
                    { name: "Attente au passe", data: src.map((x) => z(x.passe)) },
                ],
                options: {
                    ...this.socleGraphique(),
                    chart: { ...this.socleGraphique().chart, type: "bar", stacked: true },
                    colors: ["#94a3b8", "#f59e0b", "#6366f1"],
                    plotOptions: { bar: { columnWidth: "55%", borderRadius: 3 } },
                    xaxis: { categories: jours.map((j) => j.slice(8) + "/" + j.slice(5, 7)) },
                    yaxis: { title: { text: "minutes" }, labels: { formatter: (v) => Math.round(v) } },
                    tooltip: { y: { formatter: (v) => v + " min" } },
                },
            };
        },

        /* Réel vs objectif par plat, déjà agrégé et trié par le backend. */
        construireChartPlats() {
            const lignes = this.perfSrv.parPlat || [];
            this.chartPlats = {
                series: [
                    { name: "Temps réel", data: lignes.map((r) => r.reel == null ? 0 : r.reel) },
                    { name: "Objectif", data: lignes.map((r) => r.objectif == null ? 0 : r.objectif) },
                ],
                options: {
                    ...this.socleGraphique(),
                    chart: { ...this.socleGraphique().chart, type: "bar" },
                    colors: ["#ef4444", "#10b981"],
                    plotOptions: { bar: { horizontal: true, barHeight: "62%", borderRadius: 3 } },
                    xaxis: { categories: lignes.map((r) => r.nom), title: { text: "minutes" } },
                    tooltip: { y: { formatter: (v) => v + " min" } },
                },
            };
        },

        /* Volume et délai par heure : sépare « on est mauvais » de « on est débordé ».
           Agrégé par le backend (perfSrv.parHeure). */
        construireChartHeures() {
            const src = this.perfSrv.parHeure || [];
            const heures = src.map((x) => x.heure);
            this.chartHeures = {
                series: [
                    { name: "Bons reçus", type: "column", data: src.map((x) => x.bons) },
                    { name: "Cycle moyen", type: "line", data: src.map((x) => x.cycle == null ? 0 : x.cycle) },
                ],
                options: {
                    ...this.socleGraphique(),
                    chart: { ...this.socleGraphique().chart, type: "line" },
                    colors: ["#3b82f6", "#ef4444"],
                    stroke: { width: [0, 3], curve: "smooth" },
                    plotOptions: { bar: { columnWidth: "50%", borderRadius: 3 } },
                    markers: { size: [0, 4] },
                    xaxis: { categories: heures.map((h) => String(h).padStart(2, "0") + " h") },
                    yaxis: [
                        { title: { text: "bons" }, labels: { formatter: (v) => Math.round(v) } },
                        { opposite: true, title: { text: "minutes" }, labels: { formatter: (v) => Math.round(v) } },
                    ],
                },
            };
        },

        /* ══════════ Alerte d'arrivée ══════════ */

        /* Son ET vibration : en cuisine, la hotte couvre le son et le personnel
           ne regarde pas l'écran. Les deux échouent silencieusement si
           l'appareil ne les supporte pas - jamais d'erreur remontée. */
        alerter(insistant = false) {
            if (!this.alerteActive) return;
            this.bip(insistant);
            this.vibrer(insistant);
        },

        bip(insistant) {
            try {
                const Ctx = window.AudioContext || window.webkitAudioContext;
                if (!Ctx) return;
                const ctx = new Ctx();
                const notes = insistant ? [880, 1180, 880] : [880, 1180];
                notes.forEach((f, i) => {
                    const osc = ctx.createOscillator();
                    const gain = ctx.createGain();
                    const t0 = ctx.currentTime + i * 0.18;
                    osc.type = "sine";
                    osc.frequency.value = f;
                    gain.gain.setValueAtTime(0.0001, t0);
                    gain.gain.exponentialRampToValueAtTime(0.28, t0 + 0.02);
                    gain.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.16);
                    osc.connect(gain); gain.connect(ctx.destination);
                    osc.start(t0); osc.stop(t0 + 0.17);
                });
                setTimeout(() => { try { ctx.close(); } catch (e) {} }, 1200);
            } catch (e) { /* le son ne doit jamais casser l'écran */ }
        },

        vibrer(insistant) {
            try {
                if (!navigator.vibrate) return;
                navigator.vibrate(insistant ? [200, 100, 200, 100, 400] : [180, 90, 180]);
            } catch (e) { /* idem */ }
        },

        testerAlerte() {
            /* Forcé, même alerte coupée : c'est un test explicite du matériel. */
            this.bip(true);
            this.vibrer(true);
            toastr["info"](
                this.vibrationDispo
                    ? "Son et vibration déclenchés."
                    : "Son déclenché. Cet appareil ne gère pas la vibration.",
                "<b></b>"
            );
        },

        /* Relance tant qu'un bon reçu n'a pas été pris en compte : en coup de
           feu, le cuisinier s'éloigne du poste et rate le premier signal. */
        verifierRelance() {
            if (!this.alerteActive || this.etatRoom !== "connecte") return;
            if (this.bons.some((b) => b.statut === "recu")) this.alerter(false);
        },

        /* ══════════ Démonstration ══════════ */

        /**
         * Vide l'écran.
         *
         * Les bons viendront du backend (réception caisse → cuisine), qui n'est
         * pas encore construit : les listes restent donc vides, et c'est l'état
         * honnête de l'écran aujourd'hui. Rien n'est simulé.
         */
        reinitialiser() {
            this.bons = [];
            this.tousLesBons = [];
            this.lignesFaites = {};
            this.dernierRecu = "";
            this.bonSelectionne = null;
            this.page = 1;
            if (this.onglet === "performance") this.$nextTick(() => this.construireGraphiques());
        },
    },

    mounted() {
        this.vibrationDispo = typeof navigator !== "undefined" && !!navigator.vibrate;
        this.reinitialiser();
        this.appliquerPreset("jour");
        this._horloge = setInterval(() => {
            this.maintenant = Date.now();
            /* Décompte du jeton : recalculé sur l'échéance renvoyée par le
               serveur, corrigée du décalage d'horloge - un poste mural dont
               l'horloge dérive ne doit pas annoncer une fausse expiration. */
            if (this.jetonExpireAt) {
                const cible = new Date(this.jetonExpireAt).getTime();
                if (isFinite(cible)) {
                    const now = Date.now() + this.decalageHorloge;
                    this.jetonReste = Math.max(0, Math.round((cible - now) / 1000));
                }
            }
        }, 1000);
        this._relance = setInterval(() => this.verifierRelance(), RELANCE_MS);
        this.reprendreSession();
    },

    beforeUnmount() {
        clearInterval(this._horloge);
        clearInterval(this._relance);
        this.arreterBattement();
        this.deconnecterTempsReel();
    },
};
</script>

<style scoped>
/* ══════════════════════════════════════════
   ÉCRAN DE PRODUCTION (cuisine / bar)
   Re-skin charte cf-/ds- (réf. cerveauia/CHARTE-GRAPHIQUE-CF.md) : les
   couleurs sont branchées sur les tokens du template (rgb(var(--primary)),
   --success, --warning, --danger, --info) et sur les neutres --cf-* de
   src/assets/charte.css. Structure et classes cui-* conservées.
   Le bloc html.dark historique est conservé (hors périmètre charte,
   light-only) ; seul l'accent y est rebranché sur le primaire.
   Les couleurs d'étape du kanban (--c) viennent de ETAPES dans le <script>,
   volontairement verbatim.
══════════════════════════════════════════ */
.cui {
    --bg:      var(--cf-surface);
    --surface: #ffffff;
    --sunken:  var(--cf-surface-alt);
    --border:  var(--cf-border);
    --text:    var(--cf-ink);
    --text2:   var(--cf-muted);
    --accent:  rgb(var(--primary));

    background: var(--bg);
    color: var(--text);
    border-radius: var(--cf-radius);
    padding: 14px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    min-height: 70vh;
}

html.dark .cui {
    --bg:      #0f172a;
    --surface: #1e293b;
    --sunken:  #172033;
    --border:  #334155;
    --text:    #f1f5f9;
    --text2:   #94a3b8;
    --accent:  rgb(var(--primary));
}

.cui-plein { position: fixed; inset: 0; z-index: 1000; border-radius: 0; overflow-y: auto; min-height: 100vh; }

/* ── En-tête ── */
.cui-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap; }
.cui-head-l { display: flex; align-items: center; gap: 12px; }
.cui-poste {
    display: inline-flex; align-items: center; gap: 6px;
    background: rgb(var(--primary));
    color: #fff; font-weight: 700; font-size: .78rem; letter-spacing: .06em;
    padding: 8px 14px; border-radius: var(--cf-radius-sm); white-space: nowrap;
}
.cui-title { font-size: 1.05rem; font-weight: 600; margin: 0; color: var(--text); }
.cui-sub { font-size: .78rem; color: var(--text2); }
.cui-head-r { display: flex; align-items: center; gap: 8px; }

.cui-voyant {
    display: inline-flex; align-items: center; gap: 8px;
    padding: 8px 14px; border-radius: 999px; font-size: .78rem; font-weight: 600;
    border: 1px solid var(--border); background: var(--surface); color: var(--text2); cursor: pointer;
    transition: color .18s ease, border-color .18s ease;
}
.cui-dot { width: 9px; height: 9px; border-radius: 50%; background: var(--cf-faint); }
.v-connecte { color: #15803d; border-color: rgb(var(--success) / .45); }
.v-connecte .cui-dot { background: rgb(var(--success)); box-shadow: 0 0 0 3px rgb(var(--success) / .22); }
.v-connexion { color: #a16207; border-color: rgb(var(--warning) / .5); }
.v-connexion .cui-dot { background: rgb(var(--warning)); animation: cui-pulse 1s infinite; }
@keyframes cui-pulse { 50% { opacity: .3; } }

/* Voyant temps réel (lien socket vers la caisse) */
.cui-rt {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 0 12px; height: 38px; border-radius: 999px;
    font-size: .76rem; font-weight: 600;
    border: 1px solid var(--border); background: var(--surface);
}
.cui-rt i { font-size: .95rem; }
.cui-rt-dot { width: 8px; height: 8px; border-radius: 50%; background: var(--cf-faint); }
.cui-rt.rt-on { color: #15803d; border-color: rgb(var(--success) / .45); }
.cui-rt.rt-on .cui-rt-dot { background: rgb(var(--success)); box-shadow: 0 0 0 3px rgb(var(--success) / .22); }
.cui-rt.rt-wait { color: #a16207; border-color: rgb(var(--warning) / .5); }
.cui-rt.rt-wait .cui-rt-dot { background: rgb(var(--warning)); animation: cui-pulse 1s infinite; }

.cui-ibtn {
    width: 38px; height: 38px; border-radius: var(--cf-radius-sm);
    border: 1px solid var(--border); background: var(--surface); color: var(--text2);
    display: inline-flex; align-items: center; justify-content: center; cursor: pointer;
    transition: background-color .18s ease, border-color .18s ease, color .18s ease;
}
.cui-ibtn:hover {
    background: rgb(var(--primary) / .08);
    border-color: rgb(var(--primary) / .35); color: rgb(var(--primary));
}
.ib-off { color: rgb(var(--danger)); border-color: rgb(var(--danger) / .4); }

/* Bandeau de rattachement + décompte du jeton */
.cui-jeton {
    display: flex; align-items: center; gap: 13px;
    padding: 12px 16px; border-radius: var(--cf-radius);
    border: 1px solid var(--border); border-left: 4px solid var(--jc, rgb(var(--success)));
    background: var(--surface);
}
.cui-jeton-ico {
    width: 38px; height: 38px; flex: 0 0 38px; border-radius: var(--cf-radius-sm);
    display: inline-flex; align-items: center; justify-content: center;
    font-size: 1.15rem; color: var(--jc, rgb(var(--success)));
    background: color-mix(in srgb, var(--jc, rgb(var(--success))) 14%, transparent);
}
.cui-jeton-corps { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.cui-jeton-l1 { display: flex; align-items: baseline; gap: 8px; flex-wrap: wrap; }
.cui-jeton-l1 strong { font-size: .87rem; font-weight: 600; color: var(--text); }
.cui-jeton-l1 span { font-size: .76rem; color: var(--text2); }
.cui-jeton-l2 { font-size: .76rem; color: var(--text2); }
.cui-jeton-l2 b { color: var(--text); font-weight: 600; }
.cui-jeton-reste {
    display: flex; flex-direction: column; align-items: flex-end; gap: 1px; text-align: right;
}
.cui-jeton-reste span { font-size: .95rem; font-weight: 700; color: var(--jc, rgb(var(--success))); white-space: nowrap; }
.cui-jeton-reste em { font-style: normal; font-size: .68rem; color: var(--jc, rgb(var(--success))); opacity: .9; }
.cui-jeton-off {
    width: 34px; height: 34px; flex: 0 0 34px; border-radius: var(--cf-radius-sm); cursor: pointer;
    border: 1px solid var(--border); background: transparent; color: var(--text2);
    transition: color .18s ease, border-color .18s ease;
}
.cui-jeton-off:hover { color: rgb(var(--danger)); border-color: rgb(var(--danger)); }

.jt-ok   { --jc: rgb(var(--success)); }
.jt-fin  { --jc: rgb(var(--warning)); background: color-mix(in srgb, rgb(var(--warning)) 7%, var(--surface)); }
.jt-mort { --jc: rgb(var(--danger)); background: color-mix(in srgb, rgb(var(--danger)) 8%, var(--surface)); }
.cui-spin { animation: cui-rot 1s linear infinite; display: inline-block; }
@keyframes cui-rot { to { transform: rotate(360deg); } }

/* ── Bandeau de connexion ── */
.cui-connect {
    display: flex; gap: 14px; align-items: flex-start;
    background: var(--surface); border: 1px dashed var(--border);
    border-left: 4px solid rgb(var(--warning)); border-radius: var(--cf-radius); padding: 16px;
}
.cui-connect-ico { font-size: 1.6rem; color: rgb(var(--warning)); line-height: 1; }
.cui-connect-body { flex: 1; }
.cui-connect-body strong { display: block; font-size: .92rem; margin-bottom: 3px; }
.cui-connect-body p { font-size: .8rem; color: var(--text2); margin: 0 0 10px; }
.cui-connect-row { display: flex; gap: 8px; flex-wrap: wrap; }
.cui-code {
    width: 150px; text-align: center; letter-spacing: .35em; font-weight: 700;
    font-size: 1.05rem; text-transform: uppercase; padding: 9px 12px; border-radius: var(--cf-radius-sm);
    border: 1px solid rgb(var(--input-border, 203 213 225)); background: var(--sunken); color: var(--text);
    transition: border-color .18s ease, box-shadow .18s ease, background-color .18s ease;
}
.cui-code:focus {
    outline: none; border-color: rgb(var(--primary));
    box-shadow: 0 0 0 3px rgb(var(--primary) / .1); background: var(--surface);
}
.cui-connect-err { display: inline-block; margin-top: 8px; font-size: .78rem; color: rgb(var(--danger)); }

/* ── Onglets (gabarit souligné de la charte) ── */
.cui-tabs { display: flex; gap: 6px; border-bottom: 1px solid var(--border); flex-wrap: wrap; }
.cui-tab {
    display: inline-flex; align-items: center; gap: 7px;
    padding: 10px 16px; font-size: .84rem; font-weight: 600; cursor: pointer;
    border: none; background: none; color: var(--text2);
    border-bottom: 2px solid transparent; margin-bottom: -1px;
    transition: color .18s ease, background-color .18s ease, border-color .18s ease;
}
.cui-tab:hover { color: rgb(var(--primary)); }
.cui-tab.on {
    color: rgb(var(--primary)); border-bottom-color: rgb(var(--primary));
    background: rgb(var(--primary) / .08);
}
.cui-tab-badge {
    background: rgb(var(--primary)); color: #fff; font-size: .68rem; font-weight: 700;
    min-width: 19px; height: 19px; border-radius: 999px;
    display: inline-flex; align-items: center; justify-content: center; padding: 0 5px;
}
.cui-tab-badge-warn { background: rgb(var(--warning)); }

/* ── Kanban ── */
.cui-service { display: flex; flex-direction: column; gap: 12px; }
.cui-attente {
    display: flex; align-items: center; gap: 12px;
    border: 1px dashed var(--border); border-radius: var(--cf-radius);
    padding: 14px 16px; background: var(--surface);
}
.cui-attente i { font-size: 1.5rem; color: var(--text2); opacity: .7; }
.cui-attente div { display: flex; flex-direction: column; }
.cui-attente strong { font-size: .87rem; font-weight: 600; }
.cui-attente span { font-size: .77rem; color: var(--text2); }

.cui-board { display: grid; grid-template-columns: repeat(4, minmax(240px, 1fr)); gap: 12px; align-items: start; }
.cui-col {
    background: var(--sunken); border: 1px solid var(--border);
    border-radius: var(--cf-radius); padding: 10px; display: flex; flex-direction: column; gap: 9px;
}
.cui-col-head {
    display: flex; align-items: center; justify-content: space-between;
    font-size: .8rem; font-weight: 700; color: var(--c);
    padding-bottom: 8px; border-bottom: 2px solid var(--c);
}
.cui-col-title { display: inline-flex; align-items: center; gap: 6px; }
.cui-col-count {
    background: var(--c); color: #fff; min-width: 22px; height: 22px; border-radius: var(--cf-radius-xs);
    display: inline-flex; align-items: center; justify-content: center; font-size: .74rem;
}
.cui-col-bulk {
    width: 100%; padding: 7px; border-radius: var(--cf-radius-sm); cursor: pointer;
    border: 1px dashed var(--border); background: transparent; color: var(--text2);
    font-size: .76rem; font-weight: 600;
    transition: color .18s ease, border-color .18s ease;
}
.cui-col-bulk:hover { border-color: rgb(var(--primary)); color: rgb(var(--primary)); }
.cui-col-body { display: flex; flex-direction: column; gap: 9px; min-height: 90px; }
.cui-vide {
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    gap: 5px; padding: 22px 0; color: var(--text2); opacity: .55; font-size: .76rem;
}
.cui-vide i { font-size: 1.4rem; }

/* ── Carte ── */
.cui-card {
    background: var(--surface); border: 1px solid var(--border);
    border-left: 4px solid var(--cf-faint); border-radius: var(--cf-radius); padding: 11px;
    display: flex; flex-direction: column; gap: 8px;
}
.urg-orange { border-left-color: rgb(var(--warning)); }
.urg-rouge  { border-left-color: rgb(var(--danger)); }
.cui-neuf { animation: cui-flash 1.1s ease-out 3; }
@keyframes cui-flash {
    0%, 100% { box-shadow: 0 0 0 0 rgb(var(--primary) / 0); }
    50%      { box-shadow: 0 0 0 4px rgb(var(--primary) / .3); }
}

.cui-card-h { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.cui-num { font-weight: 700; font-size: .88rem; }

/* Décompte : chiffres tabulaires pour que la largeur ne saute pas chaque seconde. */
.cui-cd {
    display: inline-flex; align-items: center; gap: 5px;
    font-variant-numeric: tabular-nums; font-weight: 800; font-size: .95rem;
    padding: 3px 9px; border-radius: var(--cf-radius-xs); background: var(--sunken); color: var(--text2);
}
.cd-ok     { color: #15803d; }
.cd-orange { color: #a16207; background: rgb(var(--warning) / .16); }
.cd-rouge  { color: #b91c1c; background: rgb(var(--danger) / .13); animation: cui-blink 1.4s infinite; }
@keyframes cui-blink { 50% { opacity: .45; } }

.cui-chrono { display: inline-flex; align-items: center; gap: 4px; font-size: .74rem; font-weight: 700; color: var(--text2); }

.cui-jauge { height: 4px; border-radius: 999px; background: var(--sunken); overflow: hidden; }
.cui-jauge-fill { height: 100%; border-radius: 999px; transition: width 1s linear; }
.jf-ok { background: rgb(var(--success)); }
.jf-orange { background: rgb(var(--warning)); }
.jf-rouge { background: rgb(var(--danger)); }

.cui-meta { display: flex; flex-wrap: wrap; gap: 5px; }
.cui-tag {
    display: inline-flex; align-items: center; gap: 4px;
    background: var(--sunken); border: 1px solid var(--border);
    border-radius: var(--cf-radius-xs); padding: 2px 7px; font-size: .71rem; color: var(--text2);
}
.tag-table { font-weight: 700; color: var(--text); }
.tag-soft { opacity: .8; }
.cui-meta-num { font-size: .68rem; color: var(--text2); gap: 10px; padding-top: 2px; border-top: 1px dotted var(--border); }
.cui-client { font-style: italic; }

.cui-lignes { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 3px; }
.cui-lignes li {
    display: flex; align-items: flex-start; gap: 7px; cursor: pointer;
    padding: 5px 7px; border-radius: var(--cf-radius-xs); background: var(--sunken); font-size: .82rem;
}
.cui-lignes li.fait { opacity: .45; text-decoration: line-through; }
.cui-qte { font-weight: 800; color: rgb(var(--primary)); min-width: 24px; }
.cui-plat { flex: 1; line-height: 1.3; }
.cui-plat em { font-style: normal; color: var(--text2); font-size: .77rem; }
.cui-note { display: block; margin-top: 2px; font-size: .71rem; color: #a16207; font-weight: 600; }
.cui-obj { font-size: .68rem; color: var(--text2); opacity: .75; }
.cui-tick { color: rgb(var(--success)); opacity: 0; }
.cui-lignes li.fait .cui-tick { opacity: 1; }

/* ── Horodatage des notifications ── */
.cui-timeline {
    display: flex; flex-wrap: wrap; gap: 4px;
    padding-top: 6px; border-top: 1px dotted var(--border);
}
.tl {
    display: inline-flex; align-items: center; gap: 3px;
    font-size: .67rem; padding: 2px 6px; border-radius: var(--cf-radius-xs);
    background: var(--sunken); color: var(--text2);
}
.tl-ok { color: #15803d; }
.tl-ko { color: #b91c1c; }
.tl-attente { color: #a16207; }
.tl-info { font-weight: 700; color: rgb(var(--primary)); }

.cui-card-f { display: flex; align-items: center; gap: 7px; }
.cui-back {
    width: 32px; height: 34px; border-radius: var(--cf-radius-sm); cursor: pointer;
    border: 1px solid var(--border); background: transparent; color: var(--text2);
    transition: color .18s ease, border-color .18s ease;
}
.cui-back:hover { color: var(--text); border-color: var(--cf-faint); }
.cui-next {
    flex: 1; height: 34px; border-radius: var(--cf-radius-sm); cursor: pointer; border: none;
    background: var(--c); color: #fff; font-weight: 700; font-size: .8rem;
    display: inline-flex; align-items: center; justify-content: center; gap: 6px;
}
.cui-next:hover { filter: brightness(1.08); }
.cui-done { flex: 1; text-align: center; font-size: .78rem; color: rgb(var(--success)); font-weight: 600; }

/* ── Filtres, KPI, tableaux ── */
.cui-hist, .cui-perf { display: flex; flex-direction: column; gap: 12px; }
.cui-filtres {
    display: flex; flex-wrap: wrap; gap: 12px; align-items: center;
    background: var(--surface); border: 1px solid var(--border); border-radius: var(--cf-radius); padding: 12px;
}
.cui-presets { display: flex; gap: 5px; }
.cui-preset {
    padding: 7px 13px; border-radius: var(--cf-radius-sm); cursor: pointer; font-size: .77rem; font-weight: 600;
    border: 1px solid var(--border); background: var(--sunken); color: var(--text2);
    transition: background-color .18s ease, border-color .18s ease, color .18s ease;
}
.cui-preset:hover:not(.on) { border-color: rgb(var(--primary) / .35); color: rgb(var(--primary)); }
.cui-preset.on { background: rgb(var(--primary)); border-color: rgb(var(--primary)); color: #fff; }
.cui-filtre-grp { display: flex; align-items: center; gap: 7px; }
.cui-filtre-grp label { font-size: .77rem; color: var(--text2); }
.cui-input {
    padding: 7px 10px; border-radius: var(--cf-radius-sm); font-size: .8rem;
    border: 1px solid rgb(var(--input-border, 203 213 225)); background: var(--sunken); color: var(--text);
    transition: border-color .18s ease, box-shadow .18s ease, background-color .18s ease;
}
.cui-input:focus {
    outline: none; border-color: rgb(var(--primary));
    box-shadow: 0 0 0 3px rgb(var(--primary) / .1); background: var(--surface);
}

.cui-kpis { display: grid; grid-template-columns: repeat(5, 1fr); gap: 10px; }
.cui-kpis-6 { grid-template-columns: repeat(6, 1fr); }
.cui-kpi {
    background: var(--surface); border: 1px solid var(--border);
    border-radius: var(--cf-radius); padding: 13px; display: flex; flex-direction: column; gap: 3px;
}
.cui-kpi-l { font-size: .73rem; color: var(--text2); }
.cui-kpi strong { font-size: 1.3rem; font-weight: 700; line-height: 1.2; }
.cui-kpi em { font-style: normal; font-size: .67rem; color: var(--text2); opacity: .8; }
.cui-kpi-warn strong { color: rgb(var(--danger)); }
.cui-kpi-ok strong { color: rgb(var(--success)); }

.cui-box {
    background: var(--surface); border: 1px solid var(--border);
    border-radius: var(--cf-radius); padding: 14px; min-width: 0;
}
.cui-box-h { display: flex; flex-direction: column; gap: 2px; margin-bottom: 8px; }
.cui-box-h span { font-size: .87rem; font-weight: 600; display: inline-flex; align-items: center; gap: 6px; }
.cui-box-h span i { color: rgb(var(--primary)); }
.cui-box-h small { font-size: .72rem; color: var(--text2); }
.cui-grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }

.cui-table-wrap { background: var(--surface); border: 1px solid var(--border); border-radius: var(--cf-radius); overflow-x: auto; }
.cui-table-plain { border: none; border-radius: 0; }
.cui-table { width: 100%; border-collapse: collapse; font-size: .8rem; }
.cui-table th {
    position: sticky; top: 0; z-index: 1;
    text-align: left; padding: 11px 12px; font-weight: 600; font-size: .73rem;
    color: var(--text); background: var(--sunken); text-transform: uppercase; letter-spacing: .03em;
    border-bottom: 1px solid var(--border); white-space: nowrap;
}
.cui-table td { padding: 10px 12px; border-bottom: 1px solid var(--sunken); white-space: nowrap; }
.cui-table tbody tr:hover { background: var(--bg); }
.cui-table tbody tr:last-child td { border-bottom: none; }
.cui-td-num { font-weight: 700; }
.ta-r { text-align: right; }
.cui-td-vide { text-align: center; padding: 34px; color: var(--text2); }
.cui-jamais { color: rgb(var(--danger)); font-weight: 600; }

.cui-mini-bar { width: 90px; height: 7px; border-radius: 999px; background: var(--sunken); overflow: hidden; }
.cui-mini-bar div { height: 100%; border-radius: 999px; }
.mb-ok { background: rgb(var(--success)); }
.mb-mid { background: rgb(var(--warning)); }
.mb-ko { background: rgb(var(--danger)); }

/* Pastilles de statut : triplet pilule de la charte */
.cui-badge { padding: 3px 9px; border-radius: 999px; font-size: .7rem; font-weight: 600; }
.bd-green { background: #dcfce7; color: #15803d; }
.bd-red { background: #fee2e2; color: #b91c1c; }

.cui-pager { display: flex; align-items: center; justify-content: center; gap: 14px; font-size: .78rem; color: var(--text2); }

/* ── Traçabilité ── */
.cui-trac { display: flex; flex-direction: column; gap: 12px; }
.cui-input-lg { min-width: 260px; }
.cui-check { display: inline-flex; align-items: center; gap: 7px; font-size: .78rem; color: var(--text2); cursor: pointer; }

.cui-retour-flag {
    display: inline-flex; align-items: center; gap: 2px; margin-left: 6px;
    font-size: .66rem; font-weight: 700; padding: 1px 6px; border-radius: var(--cf-radius-xs); cursor: pointer;
    background: rgb(var(--warning) / .16); color: #a16207; border: 1px solid rgb(var(--warning) / .45);
    transition: background-color .18s ease;
}
.cui-retour-flag:hover { background: rgb(var(--warning) / .3); }

.cui-trac-split { display: grid; grid-template-columns: 340px 1fr; gap: 12px; align-items: start; }
.cui-trac-liste { padding-bottom: 6px; }
.cui-trac-scroll { display: flex; flex-direction: column; gap: 5px; max-height: 560px; overflow-y: auto; }
.cui-trac-row {
    width: 100%; text-align: left; cursor: pointer; padding: 9px 11px; border-radius: var(--cf-radius-sm);
    border: 1px solid var(--border); background: var(--sunken); color: var(--text);
    display: flex; flex-direction: column; gap: 3px;
    transition: background-color .18s ease, border-color .18s ease;
}
.cui-trac-row:hover { border-color: rgb(var(--primary) / .45); }
.cui-trac-row.on { border-color: rgb(var(--primary)); background: rgb(var(--primary) / .08); }
.cui-trac-row-l1 { display: flex; align-items: center; gap: 8px; }
.cui-trac-num { font-weight: 700; font-size: .82rem; }
.cui-trac-h { font-size: .73rem; color: var(--text2); margin-left: auto; }
.cui-trac-badge {
    display: inline-flex; align-items: center; gap: 3px; font-size: .66rem; font-weight: 700;
    padding: 1px 6px; border-radius: var(--cf-radius-xs); background: rgb(var(--warning) / .18); color: #a16207;
}
.cui-trac-row-l2 { font-size: .71rem; color: var(--text2); }

.cui-trac-detail { min-height: 320px; }
.cui-vide-lg { padding: 90px 0; }
.cui-vide-lg i { font-size: 2rem; }

.cui-trac-resume {
    display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; margin-bottom: 14px;
}
.cui-trac-resume > div {
    background: var(--sunken); border: 1px solid var(--border); border-radius: var(--cf-radius-sm);
    padding: 9px 11px; display: flex; flex-direction: column; gap: 2px;
}
.cui-trac-resume span { font-size: .69rem; color: var(--text2); }
.cui-trac-resume strong { font-size: 1rem; }
.cui-trac-resume .res-warn strong { color: #a16207; }

/* Frise : la ligne verticale est portée par le ::before des points, pas par un
   pseudo-élément du <ol>, pour qu'elle s'arrête sur le dernier événement. */
.cui-frise { list-style: none; margin: 0; padding: 0; }
.cui-frise li { display: flex; gap: 11px; padding-bottom: 14px; position: relative; }
.cui-frise li:not(:last-child)::before {
    content: ""; position: absolute; left: 13px; top: 26px; bottom: 0;
    width: 2px; background: var(--border);
}
.cui-frise-pt {
    width: 28px; height: 28px; flex: 0 0 28px; border-radius: 50%;
    display: inline-flex; align-items: center; justify-content: center;
    font-size: .82rem; background: var(--sunken); color: var(--text2);
    border: 1px solid var(--border); z-index: 1;
}
.fr-reception .cui-frise-pt { background: rgb(var(--info) / .16); color: #1d4ed8; border-color: rgb(var(--info) / .45); }
.fr-avant .cui-frise-pt     { background: rgb(var(--success) / .16); color: #15803d; border-color: rgb(var(--success) / .4); }
.fr-retour .cui-frise-pt    { background: rgb(var(--warning) / .2); color: #a16207; border-color: rgb(var(--warning) / .55); }
.fr-notif .cui-frise-pt     { background: rgb(var(--primary) / .14); color: rgb(var(--primary)); border-color: rgb(var(--primary) / .4); }
.fr-vu .cui-frise-pt        { background: var(--sunken); color: var(--text2); border-color: var(--border); }

.cui-frise-body { flex: 1; min-width: 0; padding-top: 2px; }
.cui-frise-l1 { display: flex; align-items: baseline; gap: 10px; }
.cui-frise-l1 strong { font-size: .83rem; font-weight: 600; }
.fr-retour .cui-frise-l1 strong { color: #a16207; }
.cui-frise-h { font-size: .74rem; color: var(--text2); font-variant-numeric: tabular-nums; margin-left: auto; }
.cui-frise-l2 { display: flex; gap: 10px; font-size: .71rem; color: var(--text2); }
.cui-frise-delta { margin-left: auto; font-weight: 600; opacity: .85; }

.cui-trac-plats {
    display: flex; flex-wrap: wrap; gap: 5px; align-items: center;
    padding-top: 12px; border-top: 1px dotted var(--border);
}
.cui-trac-plats-t { font-size: .71rem; color: var(--text2); margin-right: 4px; }

/* ── Boutons (gabarits charte : fantôme / primaire) ── */
.cui-btn {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 8px 14px; border-radius: var(--cf-radius-sm); cursor: pointer; font-size: .79rem; font-weight: 600;
    border: 1px solid rgb(var(--input-border, 203 213 225)); background: var(--surface); color: var(--text);
    transition: background-color .18s ease, border-color .18s ease, color .18s ease;
}
.cui-btn:hover:not(:disabled) {
    background: rgb(var(--primary) / .08);
    border-color: rgb(var(--primary) / .35); color: rgb(var(--primary));
}
.cui-btn:disabled { opacity: .45; cursor: not-allowed; }
.cui-btn-pri { background: rgb(var(--primary)); border-color: rgb(var(--primary)); color: #fff; }
.cui-btn-pri:hover:not(:disabled) {
    background: rgb(var(--primary)); border-color: rgb(var(--primary));
    color: #fff; filter: brightness(1.08);
}

/* ── Note matérielle de pied d'écran ── */
.cui-pied {
    display: flex; align-items: center; gap: 8px;
    border: 1px dashed var(--border); border-radius: var(--cf-radius); padding: 9px 13px;
    font-size: .75rem; color: #a16207;
}

/* ── Adaptatif ── */
@media (max-width: 1400px) {
    .cui-kpis-6 { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 1280px) {
    .cui-board { grid-template-columns: repeat(2, minmax(240px, 1fr)); }
    .cui-kpis  { grid-template-columns: repeat(3, 1fr); }
    .cui-grid2 { grid-template-columns: 1fr; }
    .cui-trac-split { grid-template-columns: 1fr; }
    .cui-trac-scroll { max-height: 260px; }
}
@media (max-width: 720px) {
    .cui-board { grid-template-columns: 1fr; }
    .cui-kpis, .cui-kpis-6 { grid-template-columns: repeat(2, 1fr); }
    .cui-head-r { width: 100%; justify-content: flex-end; }
    .cui-trac-resume { grid-template-columns: repeat(2, 1fr); }
    .cui-input-lg { min-width: 0; width: 100%; }
}
</style>
